/* global d3 $ _ d3plus */ /* eslint-disable-line */
import pipeService from '../../service/pipeService' /* eslint-disable-line */
import "../../assets/explorationview.css"
import globalConfig from '../../service/globalConfig';

// ------------- Utility Function -------------
/////////////////////////////////
// --- cal segment startTimes and endTimes
function calSegmentStartEndTime(segment) {
    let startTime = -1;
    let endTime = -1;
    let startTimes = [],
        endTimes = [];
    segment["sentences"].map(function(s) {
        if (s.hasOwnProperty("startTime")) {
            startTimes.push(s["startTime"]);
            endTimes.push(s["endTime"]);
        }
    })
    if (startTimes.length > 0) {
        startTime = Math.min.apply(null, startTimes);
        endTime = Math.max.apply(null, endTimes);
    }
    return [startTime, endTime]
}

// --- remove all punctuations
function regex(str) { /* eslint-disable-line */
    return str.replace(/(~|`|!|@|#|$|%|^|&|\*|\(|\)|{|}|\[|\]|;|:|\"|'|<|,|\.|>|\?|\/|\\|\||-|_|\+|=)/g, ""); /* eslint-disable-line */
}
/////////////////////////////////
// ------------- Utility Function -------------

let DrawExploration = function(id) {
    const _this = this;
    _this.id = id;
    // ---
    // story contexts (middle)

    _this.contextstory = d3.select("#contextstoryDetail").append("div");

    _this.contextWidth = $('#contextstoryDetail').width();
    _this.contextHeight = $('#contextstoryDetail').height();

    _this.marginLR = 10; // svg margin left & right 
    _this.marginTB = 5; // svg margin top & bottom

    _this.gtWidth = _this.divWidth - 2 * _this.marginLR;
    _this.gHeight = _this.divHeight - 2 * _this.marginTB;

    //  ---
    // keyword detail (left)

    _this.keywordDetailWidth = $("#contentExploration").width() * 0.6;
    _this.keywordDetail = d3.select("#keywordDetail")
        .append("svg")
        .attr("width", _this.keywordDetailWidth)
        .attr("height", $("#contentExploration").height());


    // previewbar (left)
    _this.previewBarWidth = $("#contentExploration").width();
    _this.previewBarHeight = $("#contentExploration").height();

    _this.previewSvg = d3.select("#previewBar")
        .append("svg")
        .attr("id", "previewBarSvg")
        .attr("width", _this.previewBarWidth)
        .attr("height", $("#contentExploration").height());
    ////////////////////////////////////////////////////////////
    // --- configuration (tech summary)
    ////////////////////////////////////////////////////////////
    let techTop = 3;
    let techSummaruBarHeight = 25;
    _this.techWidth = 10;
    let techLeft = 20;
    _this.techLeft = 20;
    let techLabelYoffset = techTop + techSummaruBarHeight + 22;
    ////////////////////////////////////////////////////////////
    _this.previewContextMargin = {
        // top: $("#contentExploration").height() * 0.05, 
        top: techLabelYoffset,
        right: 3,
        // bottom: $("#contentExploration").height() * 0.05, 
        bottom: 3,
        left: techLeft + 3,
    };
    // --- gpreviewBar configuration
    _this.previewContextWidth = _this.previewBarWidth - _this.previewContextMargin.left - _this.previewContextMargin.right;
    _this.previewContextHeight = _this.previewBarHeight - _this.previewContextMargin.top - _this.previewContextMargin.bottom;

    _this.gpreviw = _this.previewSvg.append("g")
        .attr('transform', 'translate(' + _this.previewContextMargin.left + ', ' + _this.previewContextMargin.top + ')');

    // --- gkeywordDetail configuration

    _this.gkeywordDetailWidth = _this.keywordDetailWidth - _this.previewContextMargin.left - _this.previewContextMargin.right;
    _this.gkeywordDetailHeight = $("#contentExploration").height() - _this.previewContextMargin.top - _this.previewContextMargin.bottom;

    _this.gkeywordDetail = _this.keywordDetail.append("g")
        .attr("id", "gkeywordDetail")
        .attr('transform', 'translate(' + (3) + ', ' + _this.previewContextMargin.top + ')');
    // .attr('transform', 'translate(' + _this.previewContextMargin.left + ', ' + _this.previewContextMargin.top + ')');

    // --- timeslider
    _this.timeslider = _this.previewSvg.append('g')
        .append('path')
        .attr('id', 'timeslider')
        .attr('d', () => {
            let d = 'M' + (_this.previewContextMargin.left - 5) + ',' + _this.previewContextMargin.top
                ///////////////////////////////////////////////////////////////////////
                //  OLD
                // d += ' ' + (_this.previewContextWidth+5) + ',' + _this.previewContextMargin.top
                ///////////////////////////////////////////////////////////////////////
            d += ' ' + (200 + 5) + ',' + _this.previewContextMargin.top
            return d
        })
        .style('stroke', 'red')
        .style('stroke-width', '1px')
        .style('vector-effect', 'non-scaling-stroke');

    // ---
    // punchline techniques
    _this.punchTechs = _this.previewSvg.append("g")
        .attr("id", "gtechDetail")
        .attr("transform", 'translate(' + (_this.previewContextMargin.left) + ', ' + (techTop) + ')');


    /////////////////////////////////////////////////////////////
    // --- humour detail content
    /////////////////////////////////////////////////////////////
    // table Height
    _this.tableH = "150px";

}

DrawExploration.prototype.layout = function(data, laughters, featureThs) { /* eslint-disable-line */
    // initialization
    const _this = this;
    console.log("inside ExplorationView (current) feature thresholds:", featureThs)
        //  redrawing 
    _this.contextstory.selectAll("*").remove();
    _this.gkeywordDetail.selectAll("*").remove();
    _this.gpreviw.selectAll("*").remove();
    _this.punchTechs.selectAll("*").remove();
    ////////////////////////////////////////////////
    _this.data = data;
    _this.laughters = laughters;
    ////////////////////////////////////////////////


    ////////////////////////////////////////////////
    ////////////////////////////////////////////////
    // draw previewContext
    let punchlineid = laughters["laughters"].map(function(d) {
        return d["preid"];
    });
    // --- get all sentences
    let sentences = [];
    data["segments"].map(function(d) {
        d["sentences"].map(function(s) {
            sentences.push(s);
        });
    });
    // --- get all punchlines
    let punchlines = [];
    punchlineid.map(function(d) {
        punchlines.push(sentences[d]);
    });
    // --- get all starttime
    let sentenceStarTimeList = []
    sentences.map(function(s, idx) {
        // console.log('s: ', s)
        s['punchlineFlag'] = false
        if (s.hasOwnProperty("startTime")) {
            // extract humor skills
            // let saudiohumor = globalConfig.extractAudioHumor(s);
            // let stexthumor = globalConfig.extractTextHumor(s); 
            // console.log("audio,text humour skills:",saudiohumor,stexthumor);
            sentenceStarTimeList.push(s.startTime)
        } else {
            if(sentences[idx - 1]!=undefined){
                sentences[idx - 1]['punchlineFlag'] = true
            }
        }
    });
    // --- draw miniature of detail view
    let duration = 0;
    sentences.map(function(d) {
        if (d.hasOwnProperty("endTime")) {
            if (d["endTime"] >= duration) {
                duration = d["endTime"];
            }
        }
    });
    _this.yScaler = d3.scaleLinear().domain([0, duration]).range([0, _this.previewContextHeight]);
    _this.drawPreviewContext({ 'punchlines': punchlines, 'sentenceStarTimeList': sentenceStarTimeList });
    ////////////////////////////////////////////////
    // --- record punchlineY offset
    // let punchlineY = [];
    // punchlines.map(function(p) {
    //     punchlineY.push(_this.yScaler(p.startTime));
    // });
    // console.log("---punchline Y offset---", punchlineY, punchlineY.length);
    // --- mapping starttimelist to sentenceidx
    let bisect = d3.bisector(function(d) { return d }).left; /* eslint-disable-line */

    ////////////////////////////////////////////////
    ////////////////////////////////////////////////

    // ---
    // contexts
    let contextLeft = 50; /* eslint-disable-line */
    let contextH = 100; /* eslint-disable-line */
    // let contextNum = Object.keys(data["storyexploration_order"]).length;
    ////////////////////////////////////////////////
    let real_segments = [];
    data["segments"].map(function(s, sid) {
        if (s["contexts"].trim() != "(~)") {
            real_segments.push(sid.toString());
        }
    });
    let contextNum = real_segments.length;
    ////////////////////////////////////////////////
    let contextLabelH = 60;
    let dLabelLineH = 10;

    // --- context link
    let contextlinkH = 20; /* eslint-disable-line */

    // --- context summary
    let contextsummaryH = 100; // total height
    let contextlenH = 10; // one  
    let contextSummaryLeft = 5;
    let contextSummaryTop = 5;

    let contextsummaryY = ((contextsummaryH - contextSummaryTop * 2)) / 2 - contextlenH;

    let contextBarH = 4;

    // ---
    // --- append rows of contexts
    for (let i = 0; i < contextNum; i++) {
        _this.contextstory.append("div")
            .attr("class", "d-flex flex-column " + "contextNum contextNum-" + i)
            .append("div")
            .attr("class", "p")
            .attr("width", _this.contextWidth)
            .attr("height", contextH)
            // .attr("id","contextstory-" + data["storyexploration_order"][i].join("-") )
            ////////////////////////////////////////////////
            .attr("id", "contextstory-" + real_segments[i])
            ////////////////////////////////////////////////
            .on("mouseover", function() {
                // data["storyexploration_order"][i].map(function(sid){ /* eslint-disable-line */
                //     // outline: thin dashed lightgray;
                //     // outline-offset: 2px;
                //     // $(".segTech-"+sid)
                //     // .css("outline","2px solid gray");
                // });
            })
            .on("mouseout", function() {
                //  --- restore humour skills summary
                // $(".gpunchsentech")
                //     .css("outline","thin dashed lightgray");
            });
    }

    // --- 
    // sentence length
    let sen_lengths = [];
    data["segments"].map(function(d) {
        let context = d["contexts"].trim().toLowerCase();
        if (context != "(~)") {
            d["sentences"].map(function(s) {
                if (s.hasOwnProperty("startTime")) {
                    sen_lengths.push(s["sentence"].trim().split(" ").length);
                }
            });
        }
        ////////////////////////////////////////////////
        ////////////////////////////////////////////////
        // --- get sentence techniques
        d["sentences"].map(function(s) {
            if (s.hasOwnProperty("startTime")) {
                let senSkills = globalConfig.extractHumorskills(s, d, featureThs);
                s['senSkills'] = senSkills;
            }
        });
        ////////////////////////////////////////////////
        ////////////////////////////////////////////////
    });

    // --- story summary/contexts configuration
    let senMaxL = 30;
    let senMinL = 10;
    let senInterval = 3; /* eslint-disable-line */
    let xSenScale = d3.scaleLinear().domain([Math.min.apply(null, sen_lengths), Math.max.apply(null, sen_lengths)]).range([senMinL, senMaxL]); /* eslint-disable-line */
    let senH = 50; /* eslint-disable-line */
    let phraseW = 20; /* eslint-disable-line */
    let senW = 80; /* eslint-disable-line */

    // --- context repetition freq
    let contextOffsetx = 5;
    let contextrepH = contextsummaryH - contextSummaryTop * 2 - contextlenH - contextOffsetx; /* eslint-disable-line */
    let contextrepLens = [];
    Object.keys(data["storyexploration_new"]).map(function(sid) {
        let segmentrep = data["storyexploration_new"][sid];
        // console.log("segmentrep:",segmentrep)
        Object.keys(segmentrep["sentence_story"]).map(function(sr) {
            contextrepLens.push(segmentrep["sentence_story"][sr].length);
        })
    })
    let ycontextrep = d3.scaleLinear()
        .domain([0, Math.max.apply(null, contextrepLens)])
        .range([contextrepH, 0]);

    // ---
    // find all substrings in string
    function find_allsubstrings(str, substr) { /* eslint-disable-line */
        let indices = [];
        let startIndex = 0;
        while (str.indexOf(substr, startIndex) > -1) {
            let index = str.indexOf(substr, startIndex);
            indices.push(index);
            startIndex = index + substr.length;
        }
        return indices;
    }


    // ---
    // keywords configuration
    let keywords = data["textstat"]["keywords"];
    let keywordHmin = 10;
    let keywordHmax = 20;

    let keywordWeights = keywords.map(function(k) {
        return k[1];
    })
    let fontScaler = d3.scaleLinear().domain([Math.min.apply(null, keywordWeights), Math.max.apply(null, keywordWeights)]).range([keywordHmin, keywordHmax]); /* eslint-disable-line */

    // ---
    // --- draw keywords

    // --- cal segment start/end times
    // --- cal new-keywords sequence
    let new_keywords = [];
    let seg_contxt = [];
    /////////////////////////////////////////////////////////////
    // --- get segment duration
    let seg_durations = [];
    /////////////////////////////////////////////////////////////
    console.log("segment duration");
    data["segments"].map(function(seg, sid) {
        let segtimes = calSegmentStartEndTime(seg);
        let segcontext = regex(seg["contexts"]).toLowerCase().trim();
        // console.log("transformed transcript",segcontext);
        if (segtimes[0] != -1) {
            let yseg = _this.yScaler(segtimes[0]);
            seg_durations.push({
                "segid": sid,
                "start": segtimes[0],
                "end": segtimes[1]
            });
            seg_contxt.push({
                "segid": sid,
                "text": segcontext,
                "ypos": yseg
            });
        }
    });
    _this.seg_durations = seg_durations;
    let currentH = -15;
    keywords.map(function(k) {
        let kw = regex(k[0]).toLowerCase().trim();
        ////////////////////////////////////////////////
        // --- (new) finding frequency
        let kwidxs = find_allsubstrings(data["transcript"].toLowerCase(), kw)

        ////////////////////////////////////////////////
        // --- find keyword segment
        let ypos = [];
        let yseg = [];
        let ysen = []; // --- [segmentid, sentenceid]

        seg_contxt.map(function(seg) {
            // --- record word indexs in the segment
            let wrdIdx = seg["text"].indexOf(kw);
            let wlabel = 0;
            let wSen = 0;
            Object.values(data["segments"][seg["segid"].toString()]["sentences"]).map(function(sen, senidx) {
                let senStart = sen["startOffset"];
                let senEnd = sen["endOffset"];
                if (wrdIdx >= senStart & wrdIdx <= senEnd) {
                    wlabel = 1
                    wSen = senidx
                }
            })
            if (wlabel == 1) {
                ypos.push(seg["ypos"]);
                yseg.push(seg["segid"]);
                ysen.push([seg["segid"], wSen]);
            }
        });
        let keywordY = ypos[0];
        // console.log(k[0],"y pos:",ypos);
        if (keywordY >= currentH + 15) {
            new_keywords.push({
                "text": k[0],
                "y": keywordY,
                // "freq": ypos.length,
                "freq": kwidxs.length,
                "segid": yseg,
                "seg-sen": ysen,
            });
            currentH = keywordY + 15;
        } else {
            new_keywords.push({
                "text": k[0],
                "y": currentH + 20,
                // "freq": ypos.length,
                "freq": kwidxs.length,
                "segid": yseg,
                "seg-sen": ysen,
            });
            currentH = currentH + 20;
        }
    });

    console.log("new keywords:", new_keywords);

    ////////////////////////////////////////////////
    // --- get new keywords frequency
    let maxKwFreq = 0;
    new_keywords.map(function(kw) {
        let freq = kw["freq"];
        if (freq > maxKwFreq) {
            maxKwFreq = freq
        }
    });
    let maxkWbarH = _this.techLeft;
    // --- keyword bar
    let kwxScler = d3.scaleLinear().domain([1, maxKwFreq]).range([0, maxkWbarH]);

    ////////////////////////////////////////////////
    // --- draw keyword bar
    new_keywords.map(function(kw) {
        let freq = kw["freq"];
        let xfreq = kwxScler(freq);
        _this.gkeywordDetail
            .append("rect")
            .attr("class", "keywordbars")
            .attr("x", 0)
            .attr("y", kw["y"])
            .attr("width", xfreq)
            .attr("height", 14);
    });
    ////////////////////////////////////////////////

    ////////////////////////////////////////////////
    // --- draw textbox
    new d3plus.TextBox()
        .data(new_keywords)
        .fontSize(13)
        .width(_this.gkeywordDetailWidth)
        // .y(function(_,di) { return 25*di; })
        .y(function(d) { return d["y"]; })
        .lineHeight(12)
        // .fontFamily("-apple-system")
        .fontFamily("Avenir")
        .select("#gkeywordDetail")
        .render();
    // --- create hovering event on keywords
    let ghighlightKw = _this.previewSvg.append("g")
        .attr('transform', 'translate(' + _this.previewContextMargin.left + ', ' + _this.previewContextMargin.top + ')');

    ///////////////////////////////////////////
    // --- mouse event in keywords divs in timeline summary
    ///////////////////////////////////////////
    // record whether keywords are clicked
    let keywords_clicked = -1;
    d3.selectAll(".d3plus-textBox").each(function(text) {
        // console.log("hovering on keywords",text.i)
        let wid = text.i;
        d3.select(this)
            .on("mouseover", function() {
                // if keywords are not clicked
                if (keywords_clicked == -1) {
                    console.log("hovering on keywords:", new_keywords[wid]);
                    let highlightwords = new_keywords[wid];
                    highlightwords["seg-sen"].map(function(segsen) {
                        let segmentid = segsen[0].toString();
                        let sentenceid = segsen[1].toString();
                        let sypos = _this.yScaler(data["segments"][segmentid]["sentences"][sentenceid]["startTime"]);
                        ghighlightKw.append("line")
                            .attr("class", "keywordline")
                            .attr("x1", 0)
                            .attr("y1", sypos)
                            .attr("x2", _this.previewContextWidth)
                            .attr("y2", sypos);
                    });
                }

            })
            .on("click", function() {
                // re-initialization
                keywords_clicked = 1;
                ghighlightKw.selectAll("*").remove();
                $(".d3plus-textBox").css({ "outline": "none" });
                ///////////////////////////////////
                let highlightwords = new_keywords[wid];
                // --- 1. highlight lines in timeline
                let seg0 = 999;
                let seginfo; /* eslint-disable-line */
                highlightwords["seg-sen"].map(function(segsen) {
                    let segmentid = segsen[0].toString();
                    let sentenceid = segsen[1].toString();
                    let sypos = _this.yScaler(data["segments"][segmentid]["sentences"][sentenceid]["startTime"]);
                    ghighlightKw.append("line")
                        .attr("class", "keywordline")
                        .attr("x1", 0)
                        .attr("y1", sypos)
                        .attr("x2", _this.previewContextWidth)
                        .attr("y2", sypos);
                    if (segsen[0] <= seg0) {
                        seg0 = segsen[0];
                        seginfo = segsen;
                    }
                });
                // --- 2. scroll contextstoryDetail
                $("#contextstoryDetail").scrollTop(
                    d3.select("#contextstory-" + seg0).node().offsetTop
                );
                // --- 3. outline style
                $(this).css({ "outline": "thin dashed red" });
                // --- 4. trigger clicking on senrect (.senrect & .punchrect)
                let senrects = d3.selectAll("#contextstory-" + seg0 + " .storysummarysvg svg g .senrect," + "#contextstory-" + seg0 + " .storysummarysvg svg g .punchrect").nodes();
                // --- dispatch click event
                console.log("selected sentences:", senrects.length);
                // --- handle abnormal cases: (comedy, ted talks)
                ////////////////////////////////////////////////////////////
                // (comedy_321: ready to die, new york city)
                if (highlightwords["text"].trim().toLowerCase() == "ready to die" | highlightwords["text"].trim().toLowerCase() == "new york city") {
                    d3.select(senrects[parseInt(seginfo[1], 10) + 1]).dispatch('click');
                } else {
                    d3.select(senrects[parseInt(seginfo[1], 10)]).dispatch('click');
                }
                ////////////////////////////////////////////////////////////


            })
            .on("mouseout", function() {
                // if keywords are not clicked
                if (keywords_clicked == -1) {
                    ghighlightKw.selectAll("*").remove();
                }
            });
    });


    // set keywords div to middle position
    // let keywordsDivHeight = 0;
    // $(".keywordDivs").each(function(){
    //     keywordsDivHeight = keywordsDivHeight + $(this).height();
    // });
    // $("#keywordDetail").css("padding-top", _this.previewContextMargin.top);

    // --- 
    // draw punchlines

    let line = d3.line() /* eslint-disable-line */
        .x(function(d) { return d[0]; }) // set the x values for the line generator
        .y(function(d) { return d[1]; }) // set the y values for the line generator 
        .curve(d3.curveMonotoneX); // apply smoothing to the line

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    // let gcontext = _this.g.append("g") /* eslint-disable-line */
    //     .attr("transform","translate(" + (contextLeft) + ",0)");
    //     // .attr("transform","translate(" + ( keywordsW + contextLeft ) + "," + ( contextTop ) + ")");

    let exploration_contexts = Object.keys(data["storyexploration_new"]);
    console.log("exploration contexts:", exploration_contexts);


    // ---
    // merge phrases
    let phrasePos_dict = {}; // record phrase position
    let newphrase_dict = {}; /* eslint-disable-line */


    function phrase_remove_duplicates(phrases) { /* eslint-disable-line */
        let new_phrases = [];
        let new_phrase_id = [];
        let new_phrase_short = {};
        let new_phrase_dict = {};

        phrases.map(function(p, pi) {
            let flag = 0;
            new_phrase_dict[p.join("-")] = [];
            new_phrases.map(function(np, npi) {
                // --- get unique merged phrases (token[5])
                if ((np.toLowerCase().trim()).indexOf(p[5].toLowerCase().trim()) > -1) {
                    flag = 1;
                    new_phrase_dict[p.join("-")].push(phrases[new_phrase_id[npi]].join("-"));
                }
            });
            if (flag == 0) {
                new_phrases.push(p[5]);
                new_phrase_id.push(pi);
                new_phrase_dict[p.join("-")].push(p.join("-"));
                new_phrase_short[p.join("-")] = p;
            }
        });
        // console.log("new phrases:",new_phrases,new_phrase_short,new_phrase_dict);
        return [new_phrase_short, new_phrase_dict];
    }

    // ---
    // --- get summary link position
    let summaryLinkxPos = {};
    // ---
    // --- create color palette
    let colorScheme = d3.scaleOrdinal(d3.schemeCategory10);

    // --- clicked event records
    let senrect_clicked = -1;
    let phrase_clicked = -1; /* eslint-disable-line */


    ////////////////////////////////////////////////
    // Object.keys(data["storyexploration_order"]).map(function(h){
    ////////////////////////////////////////////////
    real_segments.map(function(sid) {
        // let segH = (parseInt(h,10)+1) * contextH; /* eslint-disable-line */
        // --- append div for  storysummary
        // let segSummary = d3.select("#contextstory-" + data["storyexploration_order"][h].join("-")) /* eslint-disable-line */
        ////////////////////////////////////////////////
        let segSummary = d3.select("#contextstory-" + sid)
            ////////////////////////////////////////////////
            .append("div")
            .attr("class", "d-flex flex-column")
            .append("div")
            .attr("width", _this.contextWidth)
            // .attr("height", contextsummaryH)
            .attr("class", "storysummarysvg")

        // --- append div for drawing story contexts (repetition)
        ////////////////////////////////////////////////
        // let segDiv = d3.select("#contextstory-" + data["storyexploration_order"][h].join("-")) /* eslint-disable-line */
        ////////////////////////////////////////////////
        let segDiv = d3.select("#contextstory-" + sid)
            .append("div")
            .attr("class", "d-flex flex-column")
            .append("div")
            .attr("width", _this.contextWidth)
            .attr("class", "storycontextsvg")
            .attr("overflow", "scroll");

        // --- append svg for drawing story contexts (links, rep words, etc.)
        // let gcontext = segDiv.append("div");

        // --- append svg for drawing story summary 
        let svgcontextsummary = segSummary.append("svg") /* eslint-disable-line */
            // .attr("width", _this.contextWidth - 2 * (contextSummaryLeft))
            .attr("width", 3000)
            // .attr("height", contextsummaryH - 2 * (contextSummaryTop))
            .attr("height", contextsummaryH)
        let gcontextsummary = svgcontextsummary.append("g")
            .attr("transform", "translate(" + (contextSummaryLeft) + "," + (contextSummaryTop) + ")");

        ////////////////////////////////////////////////////////////
        // --- append detail divs
        let sentenceDiv = d3.select("#contextstory-" + sid)
            .append("div")
            .attr("class", "d-flex flex-column")
            .append("div")
            .attr("width", _this.contextWidth)
            .attr("height", 300)
            .attr("class", "sentenceDetailDiv")
            .attr("overflow", "scroll")
            ////////////////////////////////////////////////////////////
            // .style("display","none");
            ////////////////////////////////////////////////////////////
            ////////////////////////////////////////////////////////////
            // --- draw detial
            // let contentMultiline = 
        sentenceDiv.append("div") /* eslint-disable-line */
            .attr("class", "content-table-multiLine")
            .attr('id', 'content-table-multiLine-' + sid)
            .style('position', 'relative')
            .style('width', '100%')
            // .style('height', '100%');
            .style('height', _this.tableH);
        // console.log("segment sentence",data["segments"][sid]["sentences"],typeof(data["segments"][sid]["sentences"]));
        if (data["segments"][sid]["contexts"].trim() != "(~)") {
            // console.log("sentences",Object.values(data["segments"][sid]["sentences"]))
            // Object.values(data["segments"][sid]["sentences"]).map(function(v){
            //     if(!v.hasOwnProperty("startTime")){
            //         console.log(v);
            //     }
            // })
            _this.drawContentMultiLine(Object.values(data["segments"][sid]["sentences"]), sid);
        }


        ////////////////////////////////////////////////////////////

        // --- get segment id in the group

        // data["storyexploration_order"][h].map(function(sid, sidx){
        ////////////////////////////////////////////////////////////
        let sidx = 0;
        ////////////////////////////////////////////////////////////

        // --- context x offset
        let clx = 0;

        // console.log("segment id:",sid,typeof(sid),data["segments"].length);
        // --- context length
        let contextLens = [];

        // console.log(sid);
        let senOffset = 0; /* eslint-disable-line */
        let xRight = [];

        // ---
        // append g for each segment (punchline + contexts)
        let gseg = segDiv
            .append("div");

        let segdict = []; // --- record segment repetition length
        if (exploration_contexts.indexOf(sid.toString()) > -1) {
            // --- get sentence
            let sentence_story = data["storyexploration_new"][sid]["sentence_story"];
            // let word_story = data["storyexploration_new"][sid]["word_story"];

            let sentence_ids = Object.keys(sentence_story);

            data["segments"][sid]["sentences"].map(function(s, si) {
                // --- cal sentence length
                contextLens.push(xSenScale(s["sentence"].split(" ").length));

                if (sentence_ids.indexOf(si.toString()) > -1) {

                    let phrases = sentence_story[si.toString()];
                    // --- add segdict
                    segdict.push(phrases.length);

                    // --- append divs for breaking sentences
                    gseg.append("div")
                        .attr("class", "sentencebreak");

                    // --- get merged phrases from dataset

                    // let merged_phrases = phrases.map(function(p){
                    //     return p[5].toLowerCase().trim();
                    // })

                    // --- sort according to word order
                    phrases.sort(function(a, b) {
                        return a[1] - b[1];
                    });

                    // --- phrase sorting (sort according to phrase length & occurence order)
                    // phrases.sort(function(a,b){
                    //     // return a[1] - b[1];
                    //     if(a[0].split(" ").length==b[0].split(" ").length){
                    //         return a[1] - b[1];
                    //     }else{
                    //         return b[0].split(" ").length - a[0].split(" ").length;
                    //     }
                    // });

                    // --- get final merged unique phrases
                    let new_phrases = phrase_remove_duplicates(phrases);
                    //////////////////////////
                    // console.log(" --- new phrases: --- ",new_phrases,phrases);
                    //////////////////////////

                    let px = senOffset;
                    phrases.map(function(p) {
                        newphrase_dict[p.join("-")] = new_phrases[1][
                            [p.join("-")]
                        ]

                        if (new_phrases[0].hasOwnProperty(p.join("-"))) {
                            //  ---
                            // --- calculate positions for phrase links
                            // phrasePos_dict[p.join("-")] = [px,segH];
                            phrasePos_dict[p.join("-")] = [px, contextH - contextLabelH - dLabelLineH];
                            // ---
                            // --- draw story contexts words
                            // --- class 1: sen-segmentid-sentenceid
                            // --- class 2: sen-segmentid-wordgroupid
                            let phrasediv = gseg.append("div")
                                .attr("class", "keywords " + "sen-" + [sid, p[2]].join("-"))
                                .on("mouseover", function() {
                                    // --- if clicked on sentence -rect-
                                    if (phrase_clicked == -1) {
                                        let groupid = [];

                                        let groupsenstory = data["storyexploration_new"][sid]["sentence_story"][p[2].toString()];
                                        let senphrase = "";
                                        $(this).children().each(function() {
                                            senphrase = senphrase + $(this).html() + " ";
                                        })
                                        senphrase = senphrase.toLowerCase().trim();

                                        // console.log("selected phrases:",senphrase);

                                        // --- get groupid
                                        groupsenstory.map(function(gs) {
                                            if (senphrase.indexOf(gs[5].toLowerCase().trim()) > -1) {
                                                groupid.push(gs[4]);
                                            }
                                        });
                                        // console.log("sentence hovering group:",groupid);

                                        // --- highlight repetitionbar
                                        let repetitionBar = {};

                                        // --- get group phrases
                                        groupid.map(function(gid) {
                                            let groupphrases = data["storyexploration_new"][sid]["word_story"][gid.toString()];
                                            //  --- sort group phrase according to phrase length 
                                            // (i.e. first highlight long phrases then short ones)
                                            groupphrases.sort(function(a, b) {
                                                if (a[0].split(" ").length == b[0].split(" ").length) {
                                                    return a[1] - b[1];
                                                } else {
                                                    return b[0].split(" ").length - a[0].split(" ").length;
                                                }
                                            });
                                            // console.log("sentence hovering group:",groupid);

                                            groupphrases.map(function(ws) {
                                                if (repetitionBar.hasOwnProperty(ws[2])) {
                                                    repetitionBar[ws[2].toString()].push(ws[4]);
                                                } else {
                                                    repetitionBar[ws[2].toString()] = [];
                                                    repetitionBar[ws[2].toString()].push(ws[4]);
                                                }
                                                ///////////////////////////
                                                // --- highlight phrasediv
                                                d3.selectAll(".sen-" + [sid, ws[2]].join("-")).each(function() {

                                                    let childrenLens = $(this).children().length;
                                                    // console.log("children length:",childrenLens);
                                                    // console.log("highlight phrase length:",ws[0].split(" ").length);

                                                    // --- filter some unqualified phrases
                                                    if (ws[0].split(" ").length <= childrenLens) {
                                                        // --- get repetitive phrases
                                                        let wordPhrase = ws[0].split(" ");
                                                        let senphrase = ""
                                                        let wordphraseIdxs = [];
                                                        $(this).children().each(function(idx) {
                                                            senphrase = senphrase + $(this).html() + " "
                                                            let senphraseHtml = $(this).html().toLowerCase();
                                                            // ---
                                                            wordPhrase.map(function(wp) {
                                                                if (senphraseHtml.indexOf(wp) > -1) {
                                                                    wordphraseIdxs.push(idx);
                                                                }
                                                            });
                                                        });
                                                        // console.log("wordphraseIdx:",wordphraseIdxs,wordphraseIdxs.length,ws[0].split(" ").length);
                                                        ///////////////////////////////
                                                        // future plan: optimize sub-phrase highlighting
                                                        ///////////////////////////////

                                                        // --- get phrase position
                                                        if (senphrase.indexOf(ws[0].toLowerCase().trim()) > -1) {

                                                            $(this).children().each(function(idx) {
                                                                if (wordphraseIdxs.includes(idx)) {
                                                                    // --- set color opacity
                                                                    let rgbColor = d3.color(colorScheme(parseInt(ws[4], 10)));
                                                                    rgbColor.opacity = 0.5;

                                                                    $(this)
                                                                        .css("background", rgbColor.toString());
                                                                }

                                                            });
                                                        }
                                                    }
                                                });

                                                //////////////////////////
                                            });
                                            //  --- highlight links
                                            // class : segmentid, wordgroupid 
                                            d3.selectAll(".wordgroup-" + [sid, gid].join("-")).each(function() {
                                                d3.select(this)
                                                    .style("stroke", colorScheme(parseInt(gid, 10)))
                                                    .style("stroke-opacity", 0.7)
                                                    .style("stroke-width", 2);
                                            });



                                        });

                                        // --- fill repetitionbar
                                        Object.keys(repetitionBar).map(function(rk) {
                                            let flag = 0;
                                            // console.log("rk",rk,"repetitionBar",repetitionBar[rk]);
                                            let uniqueGroups = repetitionBar[rk].filter(onlyUnique);
                                            let uniqueGroupLens = uniqueGroups.length;
                                            d3.selectAll(".repetitionBar-" + [sid, rk.split("-")[0]].join("-")).each(function() {
                                                if (flag < uniqueGroupLens) {
                                                    // console.log(d3.select(this));
                                                    d3.select(this)
                                                        .style("fill", colorScheme(parseInt(uniqueGroups[flag], 10)))
                                                        .style("opacity", 0.8);
                                                    flag = flag + 1;
                                                }
                                            });
                                        });
                                    }

                                })
                                .on("mouseout", function() {
                                    // --- if clicked on sentence -rect-
                                    if (phrase_clicked == -1) {
                                        // --- restore link
                                        $(".wordlinks").each(function() {
                                            d3.select(this)
                                                .style("stroke", "gray")
                                                .style("stroke-width", 1);
                                        });
                                        // --- restore repetitionBar
                                        d3.selectAll(".repetitionBar").each(function() {
                                            d3.select(this)
                                                .style("fill", "gray")
                                                .style("opacity", 0.5);
                                        });
                                        // --- restore highlight phrases
                                        d3.selectAll(".phrasediv").each(function() {
                                            d3.select(this).style("background", "");
                                        });
                                    }
                                })
                                .on("click", function() {
                                    ////////////////////////////////////////////////////////////
                                    // initialization
                                    // --- restore repetitionBar
                                    $(".repetitionBar").css({ "fill": "gray" }).css("opacity", 0.5);
                                    // --- restore highlight phrases
                                    $(".phrasediv").css({ "background": "none" });
                                    // --- restore links
                                    $(".wordlinks").css("stroke", "gray").css("stroke-opacity", 1).css("stroke-width", 1);

                                    phrase_clicked = [sid, p[2]].join("-"); // segmentid, groupid
                                    ////////////////////////////////////////////////////////////

                                    let groupid = [];

                                    let groupsenstory = data["storyexploration_new"][sid]["sentence_story"][p[2].toString()];
                                    let senphrase = "";
                                    $(this).children().each(function() {
                                        senphrase = senphrase + $(this).html() + " ";
                                    })
                                    senphrase = senphrase.toLowerCase().trim();

                                    // console.log("selected phrases:",senphrase);

                                    // --- get groupid
                                    groupsenstory.map(function(gs) {
                                        if (senphrase.indexOf(gs[5].toLowerCase().trim()) > -1) {
                                            groupid.push(gs[4]);
                                        }
                                    });
                                    // console.log("sentence hovering group:",groupid);

                                    // --- highlight repetitionbar
                                    let repetitionBar = {};

                                    // --- get group phrases
                                    groupid.map(function(gid) {
                                        let groupphrases = data["storyexploration_new"][sid]["word_story"][gid.toString()];
                                        //  --- sort group phrase according to phrase length 
                                        // (i.e. first highlight long phrases then short ones)
                                        groupphrases.sort(function(a, b) {
                                            if (a[0].split(" ").length == b[0].split(" ").length) {
                                                return a[1] - b[1];
                                            } else {
                                                return b[0].split(" ").length - a[0].split(" ").length;
                                            }
                                        });
                                        // console.log("sentence hovering group:",groupid);

                                        groupphrases.map(function(ws) {
                                            if (repetitionBar.hasOwnProperty(ws[2])) {
                                                repetitionBar[ws[2].toString()].push(ws[4]);
                                            } else {
                                                repetitionBar[ws[2].toString()] = [];
                                                repetitionBar[ws[2].toString()].push(ws[4]);
                                            }
                                            ///////////////////////////
                                            // --- highlight phrasediv
                                            d3.selectAll(".sen-" + [sid, ws[2]].join("-")).each(function() {

                                                let childrenLens = $(this).children().length;
                                                // console.log("children length:",childrenLens);
                                                // console.log("highlight phrase length:",ws[0].split(" ").length);

                                                // --- filter some unqualified phrases
                                                if (ws[0].split(" ").length <= childrenLens) {
                                                    // --- get repetitive phrases
                                                    let wordPhrase = ws[0].split(" ");
                                                    let senphrase = ""
                                                    let wordphraseIdxs = [];
                                                    $(this).children().each(function(idx) {
                                                        senphrase = senphrase + $(this).html() + " "
                                                        let senphraseHtml = $(this).html().toLowerCase();
                                                        // ---
                                                        wordPhrase.map(function(wp) {
                                                            if (senphraseHtml.indexOf(wp) > -1) {
                                                                wordphraseIdxs.push(idx);
                                                            }
                                                        });
                                                    });
                                                    // console.log("wordphraseIdx:",wordphraseIdxs,wordphraseIdxs.length,ws[0].split(" ").length);
                                                    ///////////////////////////////
                                                    // future plan: optimize sub-phrase highlighting
                                                    ///////////////////////////////

                                                    // --- get phrase position
                                                    if (senphrase.indexOf(ws[0].toLowerCase().trim()) > -1) {

                                                        $(this).children().each(function(idx) {
                                                            if (wordphraseIdxs.includes(idx)) {
                                                                // --- set color opacity
                                                                let rgbColor = d3.color(colorScheme(parseInt(ws[4], 10)));
                                                                rgbColor.opacity = 0.5;

                                                                $(this)
                                                                    .css("background", rgbColor.toString());
                                                            }

                                                        });
                                                    }
                                                }
                                            });

                                            //////////////////////////
                                        });
                                        //  --- highlight links
                                        // class : segmentid, wordgroupid 
                                        d3.selectAll(".wordgroup-" + [sid, gid].join("-")).each(function() {
                                            d3.select(this)
                                                .style("stroke", colorScheme(parseInt(gid, 10)))
                                                .style("stroke-opacity", 0.7)
                                                .style("stroke-width", 2);
                                        });



                                    });

                                    // --- fill repetitionbar
                                    Object.keys(repetitionBar).map(function(rk) {
                                        let flag = 0;
                                        // console.log("rk",rk,"repetitionBar",repetitionBar[rk]);
                                        let uniqueGroups = repetitionBar[rk].filter(onlyUnique);
                                        let uniqueGroupLens = uniqueGroups.length;
                                        d3.selectAll(".repetitionBar-" + [sid, rk.split("-")[0]].join("-")).each(function() {
                                            if (flag < uniqueGroupLens) {
                                                // console.log(d3.select(this));
                                                d3.select(this)
                                                    .style("fill", colorScheme(parseInt(uniqueGroups[flag], 10)))
                                                    .style("opacity", 0.8);
                                                flag = flag + 1;
                                            }
                                        });
                                    });

                                })
                                // ---
                            p[5].toLowerCase().trim().split(" ").map(function(ph) {
                                phrasediv.append("div")
                                    .attr("height", "40px")
                                    .attr("class", "phrasediv")
                                    .html(ph);
                                // .html(p[5].toLowerCase().trim());
                            })

                        }

                    });
                    xRight.push(px);
                    senOffset = senOffset + senW;
                    // senOffset = px;
                } else { // handle repetition case = 0
                    segdict.push(0);
                }

            })

            // console.log("context for new story exploration:",data["storyexploration_new"][sid],senOffset);
        } else {
            // --- handle single laughter contexts
            data["segments"][sid]["sentences"].map(function(s) {
                // --- cal sentence length
                contextLens.push(xSenScale(s["sentence"].split(" ").length));
            });
            xRight.push(phraseW);
        }
        // ---

        // --- draw context summary
        let contextrepPos = [];
        // console.log("draw context rect:",sid, (sid == data["segments"].length -1));

        if (exploration_contexts.indexOf(sid.toString()) > -1) {
            // console.log("segdict:",segdict,contextrepLens,ycontextrep(0));
            // --- if contexts have repetitions

            contextLens.map(function(cl, cli) {
                //////////////
                // console.log("sentence", cli, "repetition", segdict[cli], clx, contextsummaryY);
                //////////////

                // --- add repetition summary
                contextrepPos.push([clx, ycontextrep(0)])
                contextrepPos.push([clx + 1 / 2 * cl, ycontextrep(segdict[cli])])
                contextrepPos.push([clx + cl + 2, ycontextrep(0)])

                // --- add summary rect
                gcontextsummary
                    .append("rect")
                    // punchline or normal sentences
                    .attr("class", function() {
                        // --- tell whether it is punchline or not
                        if ((cli == contextLens.length - 1) & (sid != data["segments"].length - 1)) {
                            return "punchrect";
                        } else {
                            return "senrect";
                        }
                    })
                    .attr("x", clx)
                    .attr("y", contextsummaryY)
                    .attr("rx", 3)
                    .attr("ry", 3)
                    .attr("width", cl)
                    .attr("height", contextlenH)
                    // --- add mouse over event
                    .on("mouseover", function() {
                        if (segdict[cli] > 0 & senrect_clicked == -1) {

                            ////////////////////
                            // console.log("mouse over sentences in summary", data["storyexploration_new"][sid]["sentence_story"][cli]);
                            ////////////////////
                            let repetitionBar = {};
                            data["storyexploration_new"][sid]["sentence_story"][cli].map(function(wg) {
                                let groupid = wg[4];
                                // --- get repetitionbar number
                                //////////////////////
                                // console.log("mouse over groups",groupid,data["storyexploration_new"][sid]["word_story"][groupid]);
                                //////////////////////
                                // highlight words according to word length (descending order)
                                let highlightedPhrases = data["storyexploration_new"][sid]["word_story"][groupid];
                                highlightedPhrases.sort(function(a, b) {
                                    if (a[0].split(" ").length == b[0].split(" ").length) {
                                        return a[1] - b[1];
                                    } else {
                                        return b[0].split(" ").length - a[0].split(" ").length;
                                    }
                                });
                                /////////////////////
                                // console.log("highlighted phrases",highlightedPhrases);
                                /////////////////////
                                highlightedPhrases.map(function(ws) {
                                    // let wskey = [ws[2],ws[4]].join("-");
                                    if (repetitionBar.hasOwnProperty(ws[2])) {
                                        repetitionBar[ws[2].toString()].push(ws[4]);
                                    } else {
                                        repetitionBar[ws[2].toString()] = [];
                                        repetitionBar[ws[2].toString()].push(ws[4]);
                                    }
                                    //////////////////////
                                    // console.log("words to be highlighted:",ws[0]);
                                    //////////////////////
                                    // --- highlight phrasediv
                                    d3.selectAll(".sen-" + [sid, ws[2]].join("-")).each(function() {

                                        let childrenLens = $(this).children().length;
                                        // console.log("children length:",childrenLens);
                                        // console.log("highlight phrase length:",ws[0].split(" ").length);

                                        // --- filter some unqualified phrases
                                        if (ws[0].split(" ").length <= childrenLens) {
                                            // --- get repetitive phrases
                                            let wordPhrase = ws[0].split(" ");
                                            let senphrase = ""
                                            let wordphraseIdxs = [];
                                            $(this).children().each(function(idx) {
                                                // console.log("words in one phrase:",idx,$(this).html());
                                                senphrase = senphrase + $(this).html() + " "
                                                let senphraseHtml = $(this).html().toLowerCase();
                                                // ---
                                                wordPhrase.map(function(wp) {
                                                    if (senphraseHtml.indexOf(wp) > -1) {
                                                        wordphraseIdxs.push(idx);
                                                    }
                                                });
                                            });
                                            // console.log("wordphraseIdx:",wordphraseIdxs,wordphraseIdxs.length,ws[0].split(" ").length);
                                            ///////////////////////////////
                                            // future plan: optimize sub-phrase highlighting
                                            ///////////////////////////////

                                            // --- get phrase position
                                            if (senphrase.indexOf(ws[0].toLowerCase().trim()) > -1) {

                                                $(this).children().each(function(idx) {
                                                    if (wordphraseIdxs.includes(idx)) {
                                                        // --- set color opacity
                                                        let rgbColor = d3.color(colorScheme(parseInt(ws[4], 10)));
                                                        rgbColor.opacity = 0.5;

                                                        $(this)
                                                            .css("background", rgbColor.toString());
                                                    }

                                                });
                                            }
                                        }
                                    });
                                });
                                // --- highlight links
                                // class : segmentid, wordgroupid 
                                d3.selectAll(".wordgroup-" + [sid, groupid].join("-")).each(function() {
                                        d3.select(this)
                                            .style("stroke", colorScheme(parseInt(groupid, 10)))
                                            .style("stroke-opacity", 0.7)
                                            .style("stroke-width", 2);
                                    })
                                    // --- fill rectangles below


                            });
                            // --- log repetitionBar[ws]
                            // console.log("--- repetitionBar ---:",repetitionBar);
                            Object.keys(repetitionBar).map(function(rk) {
                                let flag = 0;
                                // console.log("rk",rk,"repetitionBar",repetitionBar[rk]);
                                let uniqueGroups = repetitionBar[rk].filter(onlyUnique);
                                let uniqueGroupLens = uniqueGroups.length;
                                d3.selectAll(".repetitionBar-" + [sid, rk.split("-")[0]].join("-")).each(function() {
                                    if (flag < uniqueGroupLens) {
                                        // console.log(d3.select(this));
                                        d3.select(this)
                                            .style("fill", colorScheme(parseInt(uniqueGroups[flag], 10)))
                                            .style("opacity", 0.8);
                                        flag = flag + 1;
                                    }
                                })
                            })

                        }
                    })
                    .on("mouseout", function() {
                        if (segdict[cli] > 0 & senrect_clicked == -1) { // if not the same clicked, then clear all style
                            ////////////////////
                            // console.log("mouse out sentences in summary", data["storyexploration_new"][sid]["sentence_story"][cli]);
                            ////////////////////
                            // --- restore repetitionBar
                            $(".repetitionBar").css({ "fill": "gray" }).css("opacity", 0.5);
                            // --- restore highlight phrases
                            $(".phrasediv").css({ "background": "none" });
                            // --- restore links
                            $(".wordlinks").css("stroke", "gray").css("stroke-opacity", 1).css("stroke-width", 1);

                        }
                    })
                    // --- add click function (scroll to detail)
                    .on("click", function() {
                        // --- record which sentence clicked
                        senrect_clicked = cli;
                        // --- reset all outline
                        $(".tableRow").css({ "outline": "none" });
                        $('.senrect').css("stroke", "darkgray").css("stroke-width", "1px");
                        $('.punchrect').css("stroke", "").css("stroke-width", "1px");
                        $('.keywords').css("border", "none");
                        // --- restore repetitionBar
                        $(".repetitionBar").css({ "fill": "gray" }).css("opacity", 0.5);
                        // --- restore highlight phrases
                        $(".phrasediv").css({ "background": "none" });
                        // --- restore links
                        $(".wordlinks").css("stroke", "gray").css("stroke-opacity", 1).css("stroke-width", 1);

                        let senTable = $("#contextstory-" + sid + " .content-table-multiLine");
                        let selectedItem = d3.select("#contextstory-" + sid + " .content-table-multiLine .row-" + cli);

                        // console.log("clicked on sentence rectangle", selectedItem, selectedItem.node().offsetTop);
                        // console.log("selected sentenceId:",cli, senTable);
                        // --- scroll to selected sentence
                        senTable.scrollTop(selectedItem.node().offsetTop);
                        // --- outline
                        $("#contextstory-" + sid + " .content-table-multiLine .row-" + cli).css({ 'outline': '1px solid red' });
                        $(this).css("stroke", "red").css("stroke-width", 2);
                        //////////////////////////////////////////////////////
                        // --- highlight links
                        if (segdict[cli] > 0) {
                            let repetitionBar = {};
                            data["storyexploration_new"][sid]["sentence_story"][cli].map(function(wg) {
                                let groupid = wg[4];
                                // --- get repetitionbar number
                                //////////////////////
                                // console.log("mouse over groups",groupid,data["storyexploration_new"][sid]["word_story"][groupid]);
                                //////////////////////
                                // highlight words according to word length (descending order)
                                let highlightedPhrases = data["storyexploration_new"][sid]["word_story"][groupid];
                                highlightedPhrases.sort(function(a, b) {
                                    if (a[0].split(" ").length == b[0].split(" ").length) {
                                        return a[1] - b[1];
                                    } else {
                                        return b[0].split(" ").length - a[0].split(" ").length;
                                    }
                                });
                                /////////////////////
                                // console.log("highlighted phrases",highlightedPhrases);
                                /////////////////////
                                highlightedPhrases.map(function(ws) {
                                    // let wskey = [ws[2],ws[4]].join("-");
                                    if (repetitionBar.hasOwnProperty(ws[2])) {
                                        repetitionBar[ws[2].toString()].push(ws[4]);
                                    } else {
                                        repetitionBar[ws[2].toString()] = [];
                                        repetitionBar[ws[2].toString()].push(ws[4]);
                                    }
                                    //////////////////////
                                    // console.log("words to be highlighted:",ws[0]);
                                    //////////////////////
                                    // --- highlight phrasediv
                                    d3.selectAll(".sen-" + [sid, ws[2]].join("-")).each(function() {

                                        let childrenLens = $(this).children().length;
                                        // console.log("children length:",childrenLens);
                                        // console.log("highlight phrase length:",ws[0].split(" ").length);

                                        // --- filter some unqualified phrases
                                        if (ws[0].split(" ").length <= childrenLens) {
                                            // --- get repetitive phrases
                                            let wordPhrase = ws[0].split(" ");
                                            let senphrase = ""
                                            let wordphraseIdxs = [];
                                            $(this).children().each(function(idx) {
                                                // console.log("words in one phrase:",idx,$(this).html());
                                                senphrase = senphrase + $(this).html() + " "
                                                let senphraseHtml = $(this).html().toLowerCase();
                                                // ---
                                                wordPhrase.map(function(wp) {
                                                    if (senphraseHtml.indexOf(wp) > -1) {
                                                        wordphraseIdxs.push(idx);
                                                    }
                                                });
                                            });
                                            // console.log("wordphraseIdx:",wordphraseIdxs,wordphraseIdxs.length,ws[0].split(" ").length);
                                            ///////////////////////////////
                                            // future plan: optimize sub-phrase highlighting
                                            ///////////////////////////////

                                            // --- get phrase position
                                            if (senphrase.indexOf(ws[0].toLowerCase().trim()) > -1) {

                                                $(this).children().each(function(idx) {
                                                    if (wordphraseIdxs.includes(idx)) {
                                                        // --- set color opacity
                                                        let rgbColor = d3.color(colorScheme(parseInt(ws[4], 10)));
                                                        rgbColor.opacity = 0.5;

                                                        $(this)
                                                            .css("background", rgbColor.toString());
                                                    }

                                                });
                                            }
                                        }
                                    });
                                });
                                // --- highlight links
                                // class : segmentid, wordgroupid 
                                d3.selectAll(".wordgroup-" + [sid, groupid].join("-")).each(function() {
                                        d3.select(this)
                                            .style("stroke", colorScheme(parseInt(groupid, 10)))
                                            .style("stroke-opacity", 0.7)
                                            .style("stroke-width", 2);
                                    })
                                    // --- fill rectangles below


                            });
                            // --- log repetitionBar[ws]
                            // console.log("--- repetitionBar ---:",repetitionBar);
                            Object.keys(repetitionBar).map(function(rk) {
                                let flag = 0;
                                // console.log("rk",rk,"repetitionBar",repetitionBar[rk]);
                                let uniqueGroups = repetitionBar[rk].filter(onlyUnique);
                                let uniqueGroupLens = uniqueGroups.length;
                                d3.selectAll(".repetitionBar-" + [sid, rk.split("-")[0]].join("-")).each(function() {
                                    if (flag < uniqueGroupLens) {
                                        // console.log(d3.select(this));
                                        d3.select(this)
                                            .style("fill", colorScheme(parseInt(uniqueGroups[flag], 10)))
                                            .style("opacity", 0.8);
                                        flag = flag + 1;
                                    }
                                })
                            })

                        }
                        ////////////////////////////////////////////////////////
                        // --- hightlight phrases
                        $("#contextstory-" + sid + " .sen-" + sid + "-" + cli).css("border", "1px solid red");

                    })

                let contextBottom = contextsummaryY + contextlenH;
                // --- add summary repetition
                for (let i = 0; i < segdict[cli]; i++) {
                    gcontextsummary
                        .append("rect")
                        .attr("class", "repetitionBar repetitionBar-" + [sid, cli].join("-"))
                        .attr("x", clx)
                        .attr("y", contextBottom + i * (contextBarH + 1) + 2)
                        .attr("width", cl)
                        .attr("height", contextBarH)
                }
                ///////////
                // --- record summarylink x-offset
                summaryLinkxPos[[sid, cli].join("-")] = clx + cl / 2;

                // --- update context-length summary x-offset
                clx = clx + cl + 2;

            })
        } else {
            // --- if contexts DO NOT have repetitions
            contextLens.map(function(cl, cli) {
                gcontextsummary
                    .append("rect")
                    // punchline or normal sentences
                    .attr("class", function() {
                        if ((cli == contextLens.length - 1) & (sid != data["segments"].length - 1)) {
                            return "punchrect";
                        } else {
                            return "senrect";
                        }
                    })
                    .attr("x", clx)
                    .attr("y", sidx * (contextlenH + contextSummaryTop))
                    .attr("rx", 3)
                    .attr("ry", 3)
                    .attr("width", cl)
                    .attr("height", contextlenH)
                    .on("click", function() {
                        // --- reset all outline
                        $("#contextstory-" + sid + " .tableRow").css({ "outline": "none" });
                        $("#contextstory-" + sid + ' .senrect').css("stroke", "darkgray").css("stroke-width", "1px");
                        $("#contextstory-" + sid + ' .punchrect').css("stroke", "").css("stroke-width", "1px");

                        let senTable = $("#contextstory-" + sid + " .content-table-multiLine");
                        let selectedItem = d3.select("#contextstory-" + sid + " .content-table-multiLine .row-" + cli);

                        // console.log("clicked on sentence rectangle", selectedItem, selectedItem.node().offsetTop);
                        // console.log("selected sentenceId:",cli, senTable);
                        // --- scroll to selected sentence
                        senTable.scrollTop(selectedItem.node().offsetTop);
                        // --- outline
                        $("#contextstory-" + sid + " .content-table-multiLine .row-" + cli).css({ 'outline': '1px solid red' });
                        $(this).css("stroke", "red").css("stroke-width", 2);
                    })
                    //////////////
                    // --- record summarylink x-offset
                summaryLinkxPos[[sid, cli].join("-")] = clx + cl / 2;
                // ---
                clx = clx + cl + 2;
            });
            // svgcontextsummary.attr("height", (contextlenH + contextSummaryTop*2) * data["storyexploration_order"][h].length);
            svgcontextsummary.attr("height", (contextlenH + contextSummaryTop));

        }

        ////////////////////////////////////////////////////////////
        // });
        ////////////////////////////////////////////////////////////

    });

    console.log("phrase position:", phrasePos_dict);
    console.log("new phrase link position:", summaryLinkxPos);
    // ---
    //  draw phrase links

    Object.keys(data["storyexploration_new"]).map(function(sid) {
        let word_story = data["storyexploration_new"][sid]["word_story"];
        // --- get segment id
        // console.log("segment id",sid,typeof(sid));
        // ---
        // --- draw links on contextsummary
        Object.keys(word_story).map(function(ws) {
            // console.log("---",word_story[ws]);
            word_story[ws].map(function(word, wid) {
                if (wid + 1 < word_story[ws].length) {
                    //////////// 
                    // --- log segmentid, sentenceid
                    // console.log("segmentid",sid,"senid",word[2], [sid,word[2]].join("-"), );
                    // console.log("summarylink x-pos:",summaryLinkxPos[[sid,word[2]].join("-")]);
                    ////////////
                    let senid0 = word[2];
                    let senid1 = word_story[ws][wid + 1][2];
                    let y0 = contextsummaryY;
                    let xpos0 = summaryLinkxPos[[sid, senid0].join("-")];
                    let xpos2 = summaryLinkxPos[[sid, senid1].join("-")];
                    let xpos1 = (xpos0 + xpos2) / 2;
                    let y1 = y0;
                    let y2 = y0;
                    if (Math.abs(parseInt(senid1, 10) - parseInt(senid0, 10)) > 7) {
                        y1 = y0 - 35;
                    } else {
                        y1 = y0 - Math.abs(parseInt(senid1, 10) - parseInt(senid0, 10)) * 5;
                    }

                    ////////// OLD CONDITION
                    // if(parseInt(senid1,10) - parseInt(senid0,10)>4){
                    //     y1 = y0 - 20;
                    // }else if(parseInt(senid1,10) - parseInt(senid0,10)>2){
                    //     y1 = y0 - 10;
                    // }else{
                    //     y1 = y0 - 5;
                    // }
                    ////////// OLD CONDITION

                    let tPos = [
                        [xpos0, y0],
                        [xpos1, y1],
                        [xpos2, y2],
                    ];

                    // console.log("tPos:",tPos);

                    // --- draw links
                    d3.select("#contextstory-" + sid.toString() + " .storysummarysvg g")
                        .append("path")
                        // class 1: segmentid, wordgroupid
                        .attr("class", "wordlinks " + "wordgroup-" + [sid, ws].join("-"))
                        .data([tPos])
                        .attr("d", line);
                }
            });

        });



    });

    // ---
    // draw humour skills
    let humourskills = {};
    let humourtexthumour = ["disconnection", "repetition", "polarity", "subjectivity", "alliterations", "rhymes"];

    data["segments"].map(function(d, di) {
        d["sentences"].map(function(s, si) {
            if (s.hasOwnProperty("startTime") & (si == d["sentences"].length - 1)) {
                let senSkills = globalConfig.extractHumorskills(s, d, featureThs);
                // console.log("humour skills for punchlines:", di, senSkills);
                // let text_audio_skills = [];
                let text_audio_skills_dict = {};
                senSkills.map(function(word) {
                        let wrdhumour = word["texthumour"];
                        humourtexthumour.map(function(t) {
                            if (wrdhumour[t].length > 0) {
                                // text_audio_skills.push(t);
                                // --- build dictionary
                                if (text_audio_skills_dict.hasOwnProperty(t)) {
                                    text_audio_skills_dict[t] = text_audio_skills_dict[t] + 1;
                                } else {
                                    text_audio_skills_dict[t] = 1;
                                }
                            }
                        });
                        let audiohumour = word["audiohumour"];
                        audiohumour.map(function(a) {
                            if (typeof(a) == "string") {
                                // text_audio_skills.push(a); // handle audio skills
                                // --- build dictionary
                                if (text_audio_skills_dict.hasOwnProperty(a)) {
                                    text_audio_skills_dict[a] = text_audio_skills_dict[a] + 1;
                                } else {
                                    text_audio_skills_dict[a] = 1;
                                }
                            } else if (typeof(a) == "object") {
                                // text_audio_skills.push(a[0]); // handle pause
                                // --- build dictionary
                                if (text_audio_skills_dict.hasOwnProperty(a[0])) {
                                    text_audio_skills_dict[a[0]] = text_audio_skills_dict[a[0]] + 1;
                                } else {
                                    text_audio_skills_dict[a[0]] = 1;
                                }
                            }
                        });


                    })
                    // humourskills[[di,si].join("-")] = text_audio_skills.filter(onlyUnique);

                // humourskills[[di,si].join("-")] = text_audio_skills_dict;
                humourskills[di.toString()] = text_audio_skills_dict;

                // console.log("sentence humout skills dict:",text_audio_skills_dict);
                // console.log("segment punchline skills:",text_audio_skills.filter(onlyUnique));
            }
        });
        // console.log("segment skills:", humourskills[di.toString()]);
    });

    // --- humour skills statistics
    // console.log("all punchline humour skills:",humourskills,Object.values(humourskills));

    let humourskillsDict = {};

    Object.values(humourskills).map(function(sk) {
        Object.keys(sk).map(function(key) {
            if (humourskillsDict.hasOwnProperty(key)) {
                humourskillsDict[key] = humourskillsDict[key] + sk[key];
            } else {
                humourskillsDict[key] = sk[key];
            }
        });
    });
    console.log("all humour skills:", humourskillsDict, humourskills);

    ////////////////////////////////////////////////
    ////////////////////////////////////////////////
    // cal contexts lengths
    let contextLens = {};
    _this.data["segments"].map(function(seg, segid) {
        if (seg["contexts"].trim() != "(~)") {
            let senNum = seg["sentences"].length;
            contextLens[segid.toString()] = senNum;
        }
    });

    ////////////////////////////////////////////////
    ////////////////////////////////////////////////



    let skillsFreq = Object.values(humourskillsDict);
    let techfontScaler = d3.scaleLinear() /* eslint-disable-line */
        .domain([Math.min.apply(null, skillsFreq), Math.max.apply(null, skillsFreq)])
        .range([10, 25]);

    let keytechG = [ /* eslint-disable-line */
        ["repetition", "disconnection"],
        ["polarity", "subjectivity"],
        ["alliterations", "rhymes"],
        ["louder", "softer"],
        ["stress"],
        ["pause"],
        ["faster", "slower"]
    ]; /* eslint-disable-line */


    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////


    // ---
    // key techs
    let keytechs = ["repetition", "disconnection", "polarity", "subjectivity", "alliterations", "rhymes", "louder", "softer", "stress", "pause", "faster", "slower"]; /* eslint-disable-line */
    let audiotechs = ["louder", "softer", "stress", "pause", "faster", "slower"];
    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////
    // let techLeft = 50;
    // let techTop = _this.previewContextMargin.top;
    let techTop = 0;
    // let gpunchTechs = _this.punchTechs.append("g")
    //                     .attr("id","gtechDetail")
    //                     .attr("transform",'translate(' + techLeft + ', ' + techTop + ')');

    // let gpunchTechs = _this.previewSvg.append("g")
    //                     .attr("id","gtechDetail")
    //                     .attr("transform",'translate(' + (_this.previewContextMargin.left) + ', ' + (0) + ')');


    // ---
    // --- configuration
    let techSummaruBarHeight = 25;
    let techWidth = _this.techWidth; /* eslint-disable-line */
    let techHeight = 10;
    let techSumHScaler = d3.scaleLinear() /* eslint-disable-line */
        .domain([0, Math.max.apply(null, Object.values(humourskillsDict))])
        .range([techSummaruBarHeight, 0]);
    // ---
    keytechs.map(function(kt, ktid) {
        if (humourskillsDict.hasOwnProperty(kt)) {
            _this.punchTechs.append("rect")
                .attr("class", "punchlinerectTechSummary")
                .attr("x", ktid * (techWidth + 5))
                .attr("y", techSumHScaler(humourskillsDict[kt]))
                .attr("width", techWidth)
                .attr("height", techSummaruBarHeight - techSumHScaler(humourskillsDict[kt]))
                .on("mouseover", function(){
                    keytechs.map(kt_=>{
                        if(kt_!=kt){
                            $(".cell-"+kt_).addClass("unhighlighted");
                        }
                    })
                })
                .on("mouseout", function(){
                    $(".senHumorCell").removeClass("unhighlighted");
                })

        }
    });
    // --- technique color picker
    var techRecColor = d3.scaleLinear()/* eslint-disable-line */
        .domain([5, 1])
        .range(['#d73027', '#fee08b'])
        .interpolate(d3.interpolateHcl); //interpolateHsl interpolateHcl interpolateRgb

    // --- configuration (tech labels)
    let techLabelYoffset = techTop + techSummaruBarHeight; /* eslint-disable-line */
    let gtechLabels = _this.punchTechs.append("g")
        .attr("id", "gTechLabel")
        .attr("transform", 'translate(' + (0) + ', ' + (techLabelYoffset + 17) + ')');
    // --- draw tech labels
    keytechs.map(function(kt, ktid) {
        if (kt != "disconnection") {
            if (kt == "alliterations") {
                gtechLabels.append("g")
                    .attr("transform", 'translate(' + (ktid * (techWidth + 5)) + ', ' + 0 + ')')
                    .append("text")
                    // .attr('class', 'fa')
                    // .attr('font-size', '5px')
                    .attr('font-size', '14px')
                    /////////////////
                    .attr("data-toggle", "tooltip")
                    .attr("title", "alliterations")
                    /////////////////
                    .style('font-weight', 'bold')
                    .html(globalConfig.techlabels[kt])
                    .style('fill', globalConfig.allTechColor[kt])

                ////////////////////////////////////////////////////////////
                // --- refine labels
                // gtechLabels.append("g")
                //     .attr("transform",'translate(' + (ktid * (techWidth+8)) + ', ' + 7 + ')')
                //     .append("line")
                //     .attr('class', 'seglines')
                //     .attr('x1', -12)
                //     .attr("y1", -5)
                //     .attr("x2", 2)
                //     .attr("y2",-5)
                ////////////////////////////////////////////////////////////

            } else
            if (kt == "rhymes") {
                gtechLabels.append("g")
                    .attr("transform", 'translate(' + (ktid * (techWidth + 7)) + ', ' + 0 + ')')
                    .append("text")
                    // .attr('class', 'fa')
                    // .attr('font-size', '5px')
                    .attr('font-size', '14px')
                    /////////////////
                    .attr("data-toggle", "tooltip")
                    .attr("title", "rhymes")
                    /////////////////
                    .style('font-weight', 'bold')
                    .attr("text-anchor", "end")
                    .html(globalConfig.techlabels[kt])
                    .style('fill', globalConfig.allTechColor[kt])

                ////////////////////////////////////////////////////////////
                // gtechLabels.append("g")
                //     .attr("transform",'translate(' + (ktid * (techWidth+8)) + ', ' + 7 + ')')
                //     .append("line")
                //     .attr('class', 'seglines')
                //     .attr('x1', -14)
                //     .attr("y1", -5)
                //     .attr("x2", 0)
                //     .attr("y2",-5)
                ////////////////////////////////////////////////////////////

            } else {
                gtechLabels.append("g")
                    .attr("transform", 'translate(' + (ktid * (techWidth + 5)) + ', ' + 0 + ')')
                    .append("text")
                    .attr('class', 'fa')
                    // .attr('font-size', '5px')
                    .attr('font-size', '14px')
                    /////////////////
                    .attr("data-toggle", "tooltip")
                    .attr("title", kt)
                    /////////////////
                    .attr('font-weight', 'lighter')
                    .html(globalConfig.techlabels[kt])
                    .style('fill', globalConfig.allTechColor[kt])
            }


        } else {
            gtechLabels.append("g")
                .attr("transform", 'translate(' + (ktid * (techWidth + 5)) + ', ' + 0 + ')')
                .append("text")
                .attr('class', 'fas')
                // .attr('font-size', '5px')
                .attr('font-size', '14px')
                /////////////////
                .attr("data-toggle", "tooltip")
                .attr("title", kt)
                /////////////////
                // .attr('font-weight', 'lighter')
                .html(globalConfig.techlabels[kt])
                .style('fill', globalConfig.allTechColor[kt])
                ////////////////////////////////////////////////////////////
                // --- old style
                // .attr("dominant-baseline","central")
                // .attr("transform","rotate(-45,7,7) translate(8,-1)")
        }
    });
    // --- configuration (sentech)

    // let gsentech = _this.punchTechs.append("g")
    //                     .attr("id","gsentech")
    //                     .attr("transform",'translate(' + (0) + ', ' + senTechYoffset + ')');

    let gsentech = _this.gpreviw.append("g")
        .attr("id", "gsentech")
        // .attr("transform",'translate(' + (0) + ', ' + senTechYoffset + ')');

    // --- draw sentech
    let previousClick = -1; /* eslint-disable-line */
    let segids = Object.keys(humourskills).sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    // console.log("sorted segments:",segids);

    ////////////////////////////////////////////////
    let avgSkillNums = [];
    let skillsumXoffset = 3;
    let skillYs = [];
    ////////////////////////////////////////////////
    let senhumorTechAll = {} // merged sentence-level skills
    let senhumorContextLens = {} // merged sentence-level context lengths 
    let senSkillYOffset = {}
    let senSkillYrecords = []
    let timelineH = 2
    for(let sidx = 0; sidx<segids.length; sidx++){
        let s = segids[sidx];
        let gsenSummary = gsentech
            .append("g")
            .attr("class", "gpunchsentech " + "senTechSummary-" + s);
        if(senSkillYrecords.includes(s)==false){
            let punchsentences = data["segments"][s]["sentences"];
            let punchstarttime = punchsentences[punchsentences.length - 1]["startTime"];
            let punchstarttimeY = _this.yScaler(punchstarttime)
            senSkillYOffset[s] = punchstarttimeY;
            senSkillYrecords.push(s);
            ////////////////////////////////////////////////
            // --- record skill num (sentence level)
            let currSkillNums = Object.values(humourskills[s]).reduce((a, b) => a + b, 0);
            let currAudioTechNums = 0;
            Object.keys(humourskills[s]).map(function(k) {
                if (audiotechs.includes(k)) {
                    currAudioTechNums += humourskills[s][k];
                }
            });
            // --- record humor skill tech
            let senhumorTech = {}
            senhumorTech = humourskills[s];
            // --- record humor context length
            senhumorContextLens[s] = contextLens[s];
            ////////////////////////////////////////////////
            d3.select(".gpunchlines")
                .append('rect')
                .attr("class", "punchlines")
                .attr("id", "timepunchline-" + sidx)
                .attr('x', 0)
                .attr('y', punchstarttimeY)
                .attr("width", 200)
                .attr('height', timelineH)
                .style('pointer-events', 'none');
            ////////////////////////////////////////////////
            if(sidx+1<segids.length){
                for(let sidxNext = sidx+1; sidxNext<segids.length; sidxNext++){
                    let sNext = segids[sidxNext];
                    let punchsentenceNext = data["segments"][sNext]["sentences"];
                    let punchstarttimeNext = punchsentenceNext[punchsentenceNext.length - 1]["startTime"];
                    let punchstarttimeNextY = _this.yScaler(punchstarttimeNext);
                    if(Math.abs(punchstarttimeNextY-punchstarttimeY)<techHeight){
                        senSkillYOffset[sNext] = punchstarttimeY + (sidxNext-sidx) * timelineH;
                        senSkillYrecords.push(sNext);
                        ////////////////////////////////////////////////
                        // --- record skill num (sentence level)
                        currSkillNums += Object.values(humourskills[sNext]).reduce((a, b) => a + b, 0);
                        Object.keys(humourskills[sNext]).map(function(k) {
                            if (audiotechs.includes(k)) {
                                currAudioTechNums += humourskills[sNext][k];
                            }
                        });
                        // --- record humor skill tech
                        Object.keys(humourskills[sNext]).map(senhs=>{
                            if(senhumorTech.hasOwnProperty(senhs)){
                                senhumorTech[senhs] += humourskills[sNext][senhs];
                            }else{
                                senhumorTech[senhs] = 0
                                senhumorTech[senhs] += humourskills[sNext][senhs];
                            }
                        })
                        // --- record humor context length
                        senhumorContextLens[s] += contextLens[sNext]
                        ////////////////////////////////////////////////
                        // --- draw punchlines in the time matrix
                        d3.select(".gpunchlines")
                            .append('rect')
                            .attr("class", "punchlines")
                            .attr("id", "timepunchline-" + sidxNext)
                            .attr('x', 0)
                            .attr('y', punchstarttimeY + (sidxNext-sidx) * timelineH)
                            .attr("width", 200)
                            .attr('height', timelineH)
                            .style('pointer-events', 'none');
                        ////////////////////////////////////////////////
                    }
                }
                ////////////////////////////////////////////////
                // -- draw keytech sumBar
                gsenSummary.append("rect")
                    .attr("class", "keytechbars")
                    .attr("x", -currSkillNums - skillsumXoffset)
                    .attr("y", punchstarttimeY - techHeight/2)
                    .attr("width", currSkillNums)
                    .attr("height", techHeight);

                gsenSummary.append("rect")
                    .attr("class", "audiotechbars")
                    .attr("x", -currSkillNums - skillsumXoffset)
                    .attr("y", punchstarttimeY - techHeight/2)
                    .attr("width", currAudioTechNums)
                    .attr("height", techHeight);
                ////////////////////////////////////////////////
                // -- draw sentence technique bars
                keytechs.map(function(kt, ktid) {
                    if (senhumorTech.hasOwnProperty(kt) & (s != data["segments"].length - 1)) {
                        gsenSummary.append("rect")
                            .attr("class", "senHumorCell cell-"+kt)
                            .attr("x", ktid * (techWidth + 5))
                            .attr("y", punchstarttimeY - techHeight/2)
                            .attr("rx", 2)
                            .attr("ry", 2)
                            .attr("width", techWidth)
                            .attr("height", techHeight)
                            .attr("fill", techRecColor(parseInt(senhumorTech[kt], 10)))
                            .on("mouseover", function(){
                                keytechs.map(kt_=>{
                                    if(kt_!=kt){
                                        $(".cell-"+kt_).addClass("unhighlighted");
                                    }
                                    // else{
                                    //     $(".cell-"+kt).addClass("highlighted")
                                    // }
                                })
                            })
                            .on("mouseout", function(){
                                $(".senHumorCell").removeClass("unhighlighted");
                            });
                    } else {
                        gsenSummary.append("rect")
                            .attr("x", ktid * (techWidth + 5))
                            .attr("y", punchstarttimeY - techHeight/2)
                            .attr("rx", 2)
                            .attr("ry", 2)
                            .attr("width", techWidth)
                            .attr("height", techHeight)
                            .attr("fill", "none")
                    }
                });
                ////////////////////////////////////////////////
                // --- record sentence-level techniques
                senhumorTechAll[s] = senhumorTech;
            }
        }

    }
    // console.log("=== senSkillYOffset in matrix: ===", senSkillYOffset, senSkillYrecords);
    // console.log("=== senhumorContextLens, senhumorTechAll: ===", senhumorContextLens, senhumorTechAll);

    ////////////////////////////////////////////////
    // --- post speech data
    // pipeService.emitSpeechData([humourskills, contextLens]);
    pipeService.emitSpeechData([senhumorTechAll, senhumorContextLens]);
    ////////////////////////////////////////////////
    
    for(let sidx = 0; sidx<segids.length; sidx++){
        let s = segids[sidx];
        // let gpunchsentech = gsentech
        //     .append("g")
        //     .attr("class", "gpunchsentech " + "segTech-" + s);
        // console.log("context segments in matrix: ", s, sidx);
        let punchsentences = data["segments"][s]["sentences"];
        let punchstarttime = punchsentences[punchsentences.length - 1]["startTime"];
        // let techHeightUpdate = techHeight;
        ////////////////////////////////////////////////
        let skillNums = Object.values(humourskills[s]).reduce((a, b) => a + b, 0);
        // console.log("--- humor skills: ---",s,skillNums);
        let audioTechNums = 0;
        Object.keys(humourskills[s]).map(function(k) {
            if (audiotechs.includes(k)) {
                audioTechNums = audioTechNums + humourskills[s][k];
            }
        });

        ////////////////////////////////////////////////
        if (sidx != segids.length - 1) {
            avgSkillNums.push(skillNums)
            //     //  --- draw keytech sumBar
            // gpunchsentech.append("rect")
            //     .attr("class", "keytechbars")
            //     .attr("x", -skillNums - skillsumXoffset)
            //     .attr("y", _this.yScaler(punchstarttime) - techHeightUpdate/2)
            //     .attr("width", skillNums)
            //     .attr("height", techHeight);

            // gpunchsentech.append("rect")
            //     .attr("class", "audiotechbars")
            //     .attr("x", -skillNums - skillsumXoffset)
            //     .attr("y", _this.yScaler(punchstarttime) - techHeightUpdate/2)
            //     .attr("width", audioTechNums)
            //     .attr("height", techHeight);
        }
        skillYs.push(_this.yScaler(punchstarttime));
        ////////////////////////////////////////////////
        // keytechs.map(function(kt, ktid) {
        //     if (humourskills[s].hasOwnProperty(kt) & (s != data["segments"].length - 1)) {
        //         gpunchsentech.append("rect")
        //             .attr("x", ktid * (techWidth + 5))
        //             // .attr("y",sidx * (techHeight+5))
        //             .attr("y", _this.yScaler(punchstarttime) - techHeightUpdate/2)
        //             .attr("rx", 2)
        //             .attr("ry", 2)
        //             .attr("width", techWidth)
        //             .attr("height", techHeightUpdate)
        //             // .attr("fill","#ffa9a9");
        //             .attr("fill", techRecColor(parseInt(humourskills[s][kt], 10)))
        //             .on("click", function() {
        //                 if (previousClick != s) {
        //                     // $(".gpunchsentech")
        //                     //     .css("outline","thin dashed lightgray");

        //                     // $(".segTech-"+s)
        //                     //     .css("outline","2px solid gray");

        //                     previousClick = s;
        //                 } else {

        //                     // $(".segTech-"+s)
        //                     //     .css("outline","2px solid gray");
        //                 }
        //                 // let punchsentences = data["segments"][s]["sentences"];
        //                 // let punchstarttime = punchsentences[punchsentences.length-1]["startTime"]
        //                 // console.log("hover on segment punchline",punchstarttime);
        //                 // let sentenceIdx = bisect(sentenceStarTimeList, punchstarttime);
        //                 // pipeService.emitLocateSentence(sentenceIdx);
        //             })
        //             // .on("mouseout",function(){
        //             //     $(".gpunchsentech")
        //             //             .css("outline","thin dashed lightgray");
        //             // });
        //     } else {
        //         gpunchsentech.append("rect")
        //             .attr("x", ktid * (techWidth + 5))
        //             .attr("y", _this.yScaler(punchstarttime) - techHeightUpdate/2)
        //             .attr("rx", 2)
        //             .attr("ry", 2)
        //             .attr("width", techWidth)
        //             .attr("height", techHeightUpdate)
        //             .attr("fill", "none")
        //     }
        // });

    }


    ////////////////////////////////////////////////////////////
    // --- draw avg line
    let skillY0 = Math.min.apply(null, skillYs);
    let skillY1 = Math.max.apply(null, skillYs);
    gsentech
        .append("g")
        .append("line")
        .attr("class", "keytechavg")
        .attr("x1", -avgSkillNums.reduce((a, b) => a + b, 0) / avgSkillNums.length - skillsumXoffset)
        .attr("y1", skillY0)
        .attr("x2", -avgSkillNums.reduce((a, b) => a + b, 0) / avgSkillNums.length - skillsumXoffset)
        .attr("y2", skillY1)
        .style("stroke-dasharray", ("3, 3"));
    ////////////////////////////////////////////////////////////
    // --- set previewsvg width
    _this.previewSvg.attr("width", $("#gtechDetail")[0].getBoundingClientRect().width + 25);



    ////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////

    // --- set technqiues to middle
    let totalTechHeights = 0;

    $(".technGroups").each(function() {
        totalTechHeights = totalTechHeights + $(this).height();
    });


    // --- scroll contexts
    pipeService.onLocateSentence((sids) => {
        let segid = sids[0];
        let senid = sids[1]; /* eslint-disable-line */
        let elemOffsetTop = d3.select(`#contextstory-${segid}`).node().offsetTop;
        // --- restore
        $('.senrect').css("stroke", "darkgray").css("stroke-width", "1px");
        $('.punchrect').css("stroke", "").css("stroke-width", "1px");
        // ---
        $(`#contextstory-${segid} .senrect, #contextstory-${segid} .punchrect`)
            .eq(senid)
            .css("stroke", "red")
            .css("stroke-width", "2px");
        $('#contextstoryDetail').scrollTop(elemOffsetTop);
    })

    // let previousClickedSid = "-1";
    // // --- click on storysummarysvg
    // d3.selectAll(".storysummarysvg")
    //     .on("click",function(event){
    //         console.log("clicked",event);
    //         // --- reset all 
    //         let currentSegId = d3.select(this.parentNode.parentNode).attr("id").split("-")[1];
    //         d3.selectAll("#contextstory-"+currentSegId+" .tableRow").style("outline","");
    //     });
    $('.storysummarysvg').click(function(event) {
        // console.log("clicked on target", event.target.className.baseVal);
        let className = event.target.className.baseVal.split(" ")[0];
        if (className == "wordlinks" | className == "repetitionBar" | className == "") {
            // --- reset all 
            let currentSegId = d3.select(this.parentNode.parentNode).attr("id").split("-")[1];
            $("#contextstory-" + currentSegId + ' .senrect').css("stroke", "darkgray").css("stroke-width", "1px");
            $("#contextstory-" + currentSegId + ' .punchrect').css("stroke", "").css("stroke-width", "1px");
            // --- restore repetitionBar
            $(".repetitionBar").css({ "fill": "gray" }).css("opacity", 0.5);
            // --- restore highlight phrases
            $(".phrasediv").css({ "background": "none" });
            // --- restore links
            $(".wordlinks").css("stroke", "gray").css("stroke-opacity", 1).css("stroke-width", 1);
            // --- restore outline
            $(".keywords").css("border", "none");
            // --- reset table row
            $(".tableRow").css("outline", "none");
            // --- reset click event (one sentence rectangle in summary)
            senrect_clicked = -1;
            // --- reset clicked event (on keywords)
            phrase_clicked = -1;

        }
    });


    ////////////////////////////////////////////////////////////
    // adjust multiline table (height,scroll)
    ////////////////////////////////////////////////////////////
    $(".content-table-multiLine").each(function() {
        $(this).scrollTop($(this)[0].scrollHeight);
        // adjust table Height
        let tableH = $(this).height();
        let contentH = $('> table', this).height();
        if (tableH > contentH) {
            $(this).height(contentH);
        }
        // console.log("table height",$('> table', this).height(), $(this).height());
    });

    ////////////////////////////////////////////////////////////
    // adjust svg width height
    ////////////////////////////////////////////////////////////
    $(".storysummarysvg svg").each(function() {
        let clsNames = ""
        d3.select(this).select("g").selectAll("*").each(function() {
            // console.log("(this) child class", d3.select(this).attr("class"));
            clsNames = d3.select(this).attr("class") + " ";
        })
        if (clsNames.indexOf("wordlinks") > -1) { // dont adjust segments without repetitions
            //  test --- svg scale ---
            // console.log("this client svg:", 
            // d3.select(this).node().getBBox().width, 
            // d3.select(this).node().getBBox().height, 
            // d3.select(this).select("g").attr("transform"));
            // svg height/width

            let gH = d3.select(this).select("g").node().getBBox().height
            let deltay = Math.abs($(this).position().top - $(this).find("g").position().top)

            d3.select(this)
                .attr("height", d3.select(this).select("g").node().getBBox().height + 4 * 5)
                .attr("viewBox", "0 " + deltay + " " + (3000) + " " + (gH));

        }
    });


    ////////////////////////////////////////////////////////////
    // add line to connect current focus of segments (which segments are shown)
    ////////////////////////////////////////////////////////////

    // x offset from keyworddetail to contextstory
    let deltax = $("#contextstoryDetail").position().left - $("#keywordDetail").position().left; /* eslint-disable-line */
    let contextStoryH = $("#contextstoryDetail").height();
    let svglink = d3.select("#keywordDetail svg");
    svglink.selectAll(".glink").remove();

    // initialize link drawing
    let glink = svglink.insert("g", "#gkeywordDetail").attr("class", "glink");

    // --- segment durations (array to dict)
    let segDurationDict = {}
    _this.seg_durations.map(function(s) {
        segDurationDict[s.segid.toString()] = {
            "start": s.start,
            "end": s.end,
        }
    });

    console.log("segment durations:", segDurationDict);
    console.log("duration list", _this.seg_durations);

    // let preEndFlag = 0; // previous segment ending
    ////////////////////////////////////////////////////////////
    // --- focus area preview in timeline
    ////////////////////////////////////////////////////////////
    let gfocusarea = d3.select("#previewBarSvg .sentenceContext");
    let focusS = [],
        focusE = []; // focus area Yoffset start/end
    gfocusarea.selectAll(".focusRect").remove();

    $(".contextNum").each(function(i) { /* eslint-disable-line */
        let thisY = $(this).position().top;
        if (thisY >= 0 & thisY <= contextStoryH) {
            ////////////////////////////////////////////////////////////
            // draw links between timeline and contextstory
            // link position
            let x1 = 0;
            let x2 = deltax;
            let y1 = senSkillYOffset[segids[i]] + _this.previewContextMargin.top;
            // let y1 = punchlineY[i] + _this.previewContextMargin.top; // remember add a yoffset;
            let y2 = $('> div div', this).position().top + $('> div div', this).height() / 2; // Y of center position of context summary

            let tPos = [ /* eslint-disable-line */
                [x1 - 100, y1],
                [x1, y1],
                [x2, y2],
                [x2 + 100, y2],
            ];
            // --- draw links
            glink
                .append("path")
                .attr("class", "timelinecontextlinks")
                .data([tPos])
                .attr("d", line);
            ////////////////////////////////////////////////////////////
            // draw focus area in timeline (record focus area range)
            let segmentid = $('> div', this).attr('id').split("-")[1];
            // _this.data["segments"][segmentid.toString()]
            // console.log("--- segment durations ---:", _this.seg_durations);

            let start, end;
            if(segDurationDict[segmentid.toString()]!=undefined){
                if (segDurationDict[segmentid.toString()].hasOwnProperty("start")) {
                    start = segDurationDict[segmentid.toString()]["start"];
                    end = segDurationDict[segmentid.toString()]["end"];
                    focusS.push(_this.yScaler(start));
                    focusE.push(_this.yScaler(end));
                }
            }
            // let start = segDurationDict[segmentid.toString()]["start"];
            // let end = segDurationDict[segmentid.toString()]["end"];
            // if(start!=undefined && (end!=undefined)){
            //     focusS.push(_this.yScaler(start));
            //     focusE.push(_this.yScaler(end));
            // }

        }
    });
    ////////////////////////////////////////////////////////////
    //  begin drawing focus area
    if(focusS.length>0){
        gfocusarea.append("rect")
            .attr("class", "focusRect")
            .attr("x", 0)
            .attr("y", Math.min.apply(null, focusS))
            .attr("width", 200)
            .attr("height", Math.max.apply(null, focusE) - Math.min.apply(null, focusS));
    }
    

    ////////////////////////////////////////////////////////////
    // update when scrolling
    ////////////////////////////////////////////////////////////
    $("#contextstoryDetail").scroll(function() {
        // initialization
        glink.selectAll("*").remove();
        gfocusarea.selectAll(".focusRect").remove();
        focusS = [];
        focusE = [];

        $(".contextNum").each(function(i) { /* eslint-disable-line */
            let thisY = $(this).position().top;
            if (thisY >= -10 & thisY <= contextStoryH) {
                // draw links between timeline and contextstory
                let x1 = 0;
                let x2 = deltax;

                // let y1 = punchlineY[i] + _this.previewContextMargin.top; // remember add a yoffset;
                let y1 = senSkillYOffset[segids[i]] + _this.previewContextMargin.top;
                let y2 = $('> div div', this).position().top + $('> div div', this).height() / 2; // Y of center position of context summary

                let tPos = [ /* eslint-disable-line */
                    [x1 - 100, y1],
                    [x1, y1],
                    [x2, y2],
                    [x2 + 100, y2],
                ];
                // --- draw links
                glink
                    .append("path")
                    .attr("class", "timelinecontextlinks")
                    .data([tPos])
                    .attr("d", line);

                ////////////////////////////////////////////////////////////
                // draw focus area in timeline
                let segmentid = $('> div', this).attr('id').split("-")[1];
                // console.log("segmentid:",segmentid,segDurationDict[segmentid]);
                // _this.data["segments"][segmentid.toString()]
                // console.log("--- segment durations ---:", _this.seg_durations);
                // let start = segDurationDict[segmentid.toString()]["start"];
                //////////////////////////////////////////////////////////////
                // handle without "start" timestamp
                let start, end;
                if(segDurationDict[segmentid.toString()]!=undefined){
                    if (segDurationDict[segmentid.toString()].hasOwnProperty("start")) {
                        start = segDurationDict[segmentid.toString()]["start"];
                        end = segDurationDict[segmentid.toString()]["end"];
                        focusS.push(_this.yScaler(start));
                        focusE.push(_this.yScaler(end));
                    }
                }
                
                

            }
        });
        ////////////////////////////////////////////////////////////
        //  re-drawing focus area
        if(focusS.length>0){
            gfocusarea.append("rect")
                .attr("class", "focusRect")
                .attr("x", 0)
                .attr("y", Math.min.apply(null, focusS))
                .attr("width", 200)
                .attr("height", Math.max.apply(null, focusE) - Math.min.apply(null, focusS));
        }
       

    });

    ////////////////////////////////////////////////////////////
    // click on keywords div (clicked)
    ////////////////////////////////////////////////////////////
    $(".keywords").click(function() {
        console.log("clicked on keywordsDiv (class name):", $(this).attr("class"));
        // classname: (keywords sen-4-3)
        let seninfo = $(this).attr("class").split(" ")[1];
        let segmentid = seninfo.split("-")[1];
        let senid = seninfo.split("-")[2];
        // --- reset all outline
        $("#contextstory-" + segmentid + " .tableRow").css({ "outline": "none" });
        $("#contextstory-" + segmentid + ' .senrect').css("stroke", "darkgray").css("stroke-width", "1px");
        $("#contextstory-" + segmentid + ' .punchrect').css("stroke", "").css("stroke-width", "1px");
        /////////////////////////////////////////////////
        // highlight the corresponding sentences 
        let senTable = $("#contextstory-" + segmentid + " .content-table-multiLine");
        let selectedItem = d3.select("#contextstory-" + segmentid + " .content-table-multiLine .row-" + senid);
        // --- scroll to selected sentence
        senTable.scrollTop(selectedItem.node().offsetTop);
        // --- outline
        $("#contextstory-" + segmentid + " .content-table-multiLine .row-" + senid).css({ 'outline': '1px solid red' });
        // --- rsset borders of keywords & highlight clicked one
        $(".keywords").css("border", "none");
        $(this).css("border", "1px solid red");
    });


    ////////////////////////////////////////////////////////////
    // click on timeline
    ////////////////////////////////////////////////////////////
    d3.select(".sentenceContext").on("click", function() {
        let mouse = d3.mouse(this);
        let clickTime = Math.round(_this.yScaler.invert(mouse[1]));
        _this.timeslider
            .transition()
            .duration(200)
            .attr('d', () => {
                let d = 'M' + (_this.previewContextMargin.left - 5) + ',' + (mouse[1] + _this.previewContextMargin.top)
                    ////////////////////////////////////////////////////////////
                    // OLD
                    // d += ' ' + (_this.previewContextWidth+5) + ',' + (mouse[1] + _this.previewContextMargin.top)
                    ////////////////////////////////////////////////////////////
                d += ' ' + (200 + 5) + ',' + (mouse[1] + _this.previewContextMargin.top)
                return d
            })

        let segId = 0; // segment id

        _this.seg_durations.map(function(sd) {
            let seg_start = sd["start"];
            let seg_end = sd["end"];
            if (clickTime >= seg_start & clickTime <= seg_end) {
                segId = sd["segid"];
            }
        });

        let senId = 0; // sentence id in the segment
        // let senLabel = 0;
        Object.values(_this.data["segments"][segId.toString()]["sentences"]).map(function(s, sid) {
            if (s.hasOwnProperty("startTime")) {
                if (clickTime >= s["startTime"] & clickTime <= s["endTime"]) {
                    // if(clickTime >= s["startTime"] & senLabel==0){
                    senId = sid;
                    // senLabel = 1;
                }
            }
        });
        // --- scroll contextstoryDetail
        $("#contextstoryDetail").scrollTop(
            d3.select("#contextstory-" + segId).node().offsetTop
        );
        // --- trigger clicking on senrect (.senrect & .punchrect)
        let senrects = d3.selectAll("#contextstory-" + segId + " .storysummarysvg svg g .senrect," + "#contextstory-" + segId + " .storysummarysvg svg g .punchrect").nodes();
        // --- dispatch click event
        d3.select(senrects[parseInt(senId, 10)]).dispatch('click');



    });

    ////////////////////////////////////////////////////////////
    // click on keywordcontextlink
    ////////////////////////////////////////////////////////////
    $("#keywordcontextlink").click(function() {
        // --- reset (highlighting keyword occurences in timeline)
        ghighlightKw.selectAll("*").remove();
        // --- remove 
        $(".d3plus-textBox").css("outline", "none");
        // --- reset keyword clicked
        keywords_clicked = -1;

    });

    ////////////////////////////////////////////////////////////
    // update filtering value
    ////////////////////////////////////////////////////////////
    // --- cal punchline y offset
    let yPosDict = {};
    Object.keys(humourskills).map(function(h) {
        let punchsentences = _this.data["segments"][h]["sentences"];
        let punchstarttime = punchsentences[punchsentences.length - 1]["startTime"];
        yPosDict[h] = punchstarttime;
    });
    console.log("punchline starttime:", yPosDict);

    ////////////////////////////////////////////////////////////
    // update filtering value
    ////////////////////////////////////////////////////////////
    pipeService.onSubmitFilter(filtering => {
        console.log("--- updated filtering value (in the explorationview): ---", filtering);
        $(".gpunchsentech").show();
        $(".segmentmasks").remove();
        $(".segmentmasksReverse").remove();
        // console.log("this.humorskills", humourskills);
        let humorType = globalConfig.humorskillsType;
        // let humorskills = JSON.parse(JSON.stringify(humourskills));
        let senhumorTechAllCopy = JSON.parse(JSON.stringify(senhumorTechAll));
        // --- tell what segments to be reserved
        let seg_to_filter = [];
        Object.keys(senhumorTechAllCopy).map(function(h) {
            humorType.map(function(t) {
                let filterval = filtering[t];
                if (senhumorTechAllCopy[h].hasOwnProperty(t)) {
                    let segval = senhumorTechAllCopy[h][t]
                    if ((segval > filterval[1]) || (segval < filterval[0])) {
                        seg_to_filter.push(parseInt(h, 10));
                        // console.log(".segTech-" + h);
                        $(".senTechSummary-" + h).hide();
                    }
                } else {
                    // ---handle humorskills freq. == 0
                    let segval = 0;
                    if ((segval > filterval[1]) || (segval < filterval[0])) {
                        seg_to_filter.push(parseInt(h, 10));
                        $(".senTechSummary-" + h).hide();
                    }
                }
            });
        });

        // --- filter according to context lengths
        let contxtfilterval = filtering["contextlens"];
        real_segments.map(function(rs) {
            if ((contextLens[rs] < contxtfilterval[0]) || (contextLens[rs] > contxtfilterval[1])) {
                seg_to_filter.push(parseInt(rs, 10));
                $(".senTechSummary-" + rs).hide();
            }
        });

        // --- filtering according to textual/audio features
        let textfilterval = filtering["textualval"];
        let audiofilterval = filtering["audioval"];
        Object.keys(senhumorTechAllCopy).map(function(segid) {
            let sk = senhumorTechAllCopy[segid];

            // console.log("current segment id", segid, _this.data["segments"][segid]["sentences"][_this.data["segments"][segid]["sentences"].length - 1])
            // console.log("current segment id", segid, sk);

            let seg_text_skills = 0;
            let seg_audio_skills = 0;
            Object.keys(sk).map(function(skt) {
                // let curr_text_skills = 0;
                // let curr_audio_skills = 0;
                if (globalConfig.textualhumorTypes.indexOf(skt) > -1) {
                    seg_text_skills = seg_text_skills + sk[skt];
                    // curr_text_skills = sk[skt];
                } else if (globalConfig.audiohumorTypes.indexOf(skt) > -1) {
                    seg_audio_skills = seg_audio_skills + sk[skt];
                    // curr_audio_skills = sk[skt];
                }
            });
            // --- audio/text skills
            // --- handle textual val
            if (seg_text_skills < textfilterval[0] || seg_text_skills > textfilterval[1]) {
                seg_to_filter.push(parseInt(segid, 10));
                $(".senTechSummary-" + segid).hide();
            }
            // --- handle audio val
            if (seg_audio_skills < audiofilterval[0] || seg_audio_skills > audiofilterval[1]) {
                seg_to_filter.push(parseInt(segid, 10));
                $(".senTechSummary-" + segid).hide();
            }

        });


        // console.log("segments to be filtered:", seg_to_filter.filter(onlyUnique));
        // console.log("real segments:", real_segments, _this.data["segments"][2]["contexts"], contextLens);
        // let segidInts = real_segments.map(function(sid){ /* eslint-disable-line */
        //     return parseInt(sid, 10);
        // });
        // // --- calculate substraction
        let remain_segments = real_segments.filter(function(v) { return seg_to_filter.indexOf(parseInt(v, 10)) == -1 })

        // let remain_segments = real_segments.filter(function(v) { return seg_to_filter.indexOf(v) == -1 })

        // console.log("remaining segments:", remain_segments, _this.data["segments"]["2"]["contexts"]);
        // --- get remainnig segments
        // remain_segments.map(function(rs){
        // });
        if (seg_to_filter.filter(onlyUnique).length > 0) {
            remain_segments.map(function(segid) {
                let curr_segidxs = real_segments.indexOf(segid.toString());
                // console.log("current segment:", segid, curr_segidxs);
                let segh0 = 0;
                let segh1 = _this.yScaler(yPosDict[segid.toString()]);
                if (curr_segidxs > 0) {
                    let presegid = real_segments[curr_segidxs - 1];
                    segh0 = _this.yScaler(yPosDict[presegid]) + 2;
                    // console.log("previous segments:", presegid)
                }

                // let segh0 = _this.yScaler(segtime[0]);
                // let segh1 = _this.yScaler(segtime[1]);
                if (segid != _this.data["segments"].length - 1) {
                    d3.select(".sentenceContext")
                        .append("rect")
                        .attr("class", "segmentmasks")
                        .attr("x", 0)
                        .attr("y", segh0)
                        .attr("width", 200)
                        .attr("height", segh1 - segh0)
                        // --- style customization
                        // .style("stroke", "black")
                        // .style("stroke-width", "1px")
                        // .style("stroke-dasharray", "200, " + (segh1 - segh0));
                }

            });
        }


        // seg_to_filter.map(function(segid){
        //     let segtime = calSegmentStartEndTime(_this.data["segments"][segid]);
        //     console.log("segment time:", segid, segtime);
        //     let segh0 = _this.yScaler(segtime[0]);
        //     let segh1 = _this.yScaler(segtime[1]);
        //     d3.select(".sentenceContext")
        //         .append("rect")
        //         .attr("class", "segmentmasksReverse")
        //         .attr("x", 0)
        //         .attr("y", segh0)
        //         .attr("width", 200)
        //         .attr("height", segh1 - segh0)
        // })

    });


    ////////////////////////////////////////////////////////////
    // update tooltip
    ////////////////////////////////////////////////////////////
    $("[data-toggle='tooltip']").tooltip();


    ////////////////////////////////////////////////////////////
    // add collapse for context summary
    ////////////////////////////////////////////////////////////
    let contxtsummarysvgs = $(".storysummarysvg svg g");
    contxtsummarysvgs.map((g) => {
        let senrects = $(".senrect", contxtsummarysvgs[g]);
        let punchrects = $(".punchrect", contxtsummarysvgs[g]);
        // console.log(g, "senrect length:", senrects.length, "punchlinerect length:", punchrects.length);
        let lastrect = senrects[senrects.length - 1];

        if (punchrects.length > 0) {
            lastrect = punchrects[0];
            // console.log($(lastrect).attr("x"), $(lastrect).attr("y"), $(lastrect).attr("width"));
        }

        let rightmostX = parseInt($(lastrect).attr("x"), 10) + parseInt($(lastrect).attr("width"), 10);
        let rightmostY = parseInt($(lastrect).attr("y"), 10);
        d3.select(contxtsummarysvgs[g])
            .append("text")
            .attr("class", "far collaposeContxt")
            .attr("font-size", "5px")
            .attr('font-weight', 'lighter')
            .attr("transform", "translate(" + (rightmostX + 10) + "," + (rightmostY + 10) + ")")
            .text("\uf151")
            .on("click", function() {
                let parContxt = $(contxtsummarysvgs[g]).parent().parent().parent().parent();
                let multiContxtTable = $(parContxt);
                // let tableTotalH = multiContxtTable.find("> * > * > .content-table-multiLine").css("height");
                let tableRealH = multiContxtTable.find("> * > * > .content-table-multiLine .fixHeaderTable").css("height");
                let tableH = parseInt(tableRealH.slice(0, -2));
                // let thisClass = $(this).attr("class");
                // if (thisClass.includes("fa-rotate-180")) {
                //     $(this).removeClass("fa-rotate-180");
                // } else {
                //     $(this).addClass("fa-rotate-180");
                // }
                if ($(this).text() == "\uf151") {
                    $(this).text("\uf150");
                    if (tableH > 150) {
                        multiContxtTable.find("> * > * > .content-table-multiLine").css("height", tableH.toString() + "px");
                    }
                } else {
                    $(this).text("\uf151");
                    if (tableH > 150) {
                        multiContxtTable.find("> * > * > .content-table-multiLine").css("height", "150px");
                    }
                }
                ////////////////////////////////////////////////////////////
                let currentScroll = $('#contextstoryDetail').scrollTop();
                $('#contextstoryDetail').scrollTop(currentScroll + 1);
            });
    })


    ////////////////////////////////////////////////////////////
    // adjust font-size
    ////////////////////////////////////////////////////////////
    $(".innerWord").css("font-size", "13px");
    $(".word").css("margin-bottom", "6px");
    $(".word").css("margin-top", "4px");
    // $(".word").css("padding", "0px");
    $(".phrasediv").css("font-size", "13px");


};

DrawExploration.prototype.drawPreviewContext = function(data) {
    const _this = this
    let punchlines = data['punchlines'];
    console.log("punchlines: ", punchlines);
    // let sentenceStarTimeList = data['sentenceStarTimeList'] 
    // let bisect = d3.bisector(function(d) { return d }).left

    _this.gpreviw.selectAll('*').remove()
    _this.gpreviw.append('g')
        .attr('class', 'sentenceContext')
        .append("rect")
        .attr("class", "contextlink")
        .attr("x", 0)
        .attr("y", 0)
        // .attr("width", _this.previewContextWidth)
        .attr("width", 200)
        .attr("height", _this.previewContextHeight)
        ////////////////////////////////////////////////////////////
        // --- OLD Click
        ////////////////////////////////////////////////////////////
        // .on('click', function () {
        //     let mouse = d3.mouse(this)
        //     let clickTime = Math.round( _this.yScaler.invert(mouse[1]))
        //     // console.log("click time",clickTime,mouse[1]);
        //     // console.log('durationTime: ', durationTime)
        //     _this.timeslider
        //         .transition()
        //         .duration(200)
        //         .attr('d', () => {
        //             let d = 'M' + (_this.previewContextMargin.left - 5) + ',' + (mouse[1] + _this.previewContextMargin.top)
        //             ////////////////////////////////////////////////////////////
        //             // OLD
        //             // d += ' ' + (_this.previewContextWidth+5) + ',' + (mouse[1] + _this.previewContextMargin.top)
        //             ////////////////////////////////////////////////////////////
        //             d += ' ' + (200+5) + ',' + (mouse[1] + _this.previewContextMargin.top)
        //             return d
        //         })

    //     // let sentenceIdx = bisect(sentenceStarTimeList, clickTime)
    //     let segId = 0;

    //     _this.seg_durations.map(function(sd){
    //         let seg_start = sd["start"];
    //         let seg_end = sd["end"];
    //         if(clickTime >= seg_start & clickTime <= seg_end){
    //             segId = sd["segid"];
    //         }
    //     });
    //     ////////////////////////////////////////////////
    //     let senId = 0
    //     // let senLabel = 0;
    //     Object.values(_this.data["segments"][segId.toString()]["sentences"]).map(function(s,sid){
    //         if(s.hasOwnProperty("startTime")){
    //             if(clickTime >= s["startTime"] & clickTime <= s["endTime"]){
    //             // if(clickTime >= s["startTime"] & senLabel==0){
    //                 senId = sid;
    //                 // senLabel = 1;
    //             }
    //         }
    //     })
    //     ////////////////////////////////////////////////
    //     // --- locate segment
    //     pipeService.emitLocateSentence([segId,senId]);
    //     ////////////////////////////////////////////////
    //     // let elemOffsetTop = d3.select(`.tableRow.row-${sentenceIdx}`).node().offsetTop-30
    //     // // console.log('row i: ', sentenceIdx)
    //     // $('.scrollContent').scrollTop(elemOffsetTop)
    //     ////////////////////////////////////////////////
    // })
    ////////////////////////////////////////////////////////////

    _this.gpreviw.append('g')
        .attr('class', 'gpunchlines');
     //////////////////////////////////////////////////////////// 
        // .selectAll('rect')
        // .data(punchlines)
        // .enter()
        // .append('rect')
        // .attr("class", "punchlines")
        // .attr("id", function(_, di) {
        //     return "timepunchline-" + di;
        // })
        // .attr('x', 0)
        // .attr('y', (d) => _this.yScaler(d['startTime']))
        // // .attr('width', _this.previewContextWidth)
        // .attr("width", 200)
        // .attr('height', 2)
        // // .attr('fill', 'lightblue')
        // .style('pointer-events', 'none');

};


DrawExploration.prototype.drawContentMultiLine = function(data, sid) {
    const _this = this
    let contentMultiLine = d3.select("#content-table-multiLine-" + sid)
    contentMultiLine.selectAll('*').remove();
    // _this.contentMultiLine.selectAll('*').remove()
    let sentences = data

    let repetitionFlag = {
        'sentenceIdx': -1,
        'repetition': 0
    }
    let disconnectionFlag = {
        'sentenceIdx': -1,
        'disconnection': 0,
    }

    // console.log('sentences: ', sentences)
    // let table = _this.contentMultiLine.append('table')
    let table = contentMultiLine.append('table')
        .attr('class', 'multiline fixHeaderTable')
        .style('position', 'static')
        .style('visibility', 'visible')
        .style('width', '100%')
        // .style('height', '100%')
        .style('table-layout', 'fixed')

    // let thead = table.append('thead').attr('class', 'multiline fixedHeader')
    let tbody = table.append('tbody').attr('class', 'multiline list scrollContent')

    // console.log('thead: ', thead)
    // console.log('tbody: ', tbody)
    let columns = ['sentenceIdx', 'sentenceContext']
    // console.log('columns: ', columns)

    // create a row for each object in the data
    let rows = tbody.selectAll('tr')
        .data(sentences.filter((d) => d.hasOwnProperty("startTime")))
        .enter()
        .append('tr')
        .attr('class', (d, i) => {
            return 'multiline tableRow ' + 'row-' + i
        })
        .attr('selected', false)
        .style('background-color', 'white')

    // console.log('rows: ', rows)

    // create a cell in each row for each column
    rows.selectAll('td')
        .data(function(tableRow, rowIdx) {
            let startTime = tableRow['startTime']
            let endTime = tableRow['endTime']
            return columns.map(function(column) {
                if (column === 'sentenceContext') {
                    return { column: 'sentenceContextExp', value: tableRow, punchlineFlag: tableRow.punchlineFlag, startTime: startTime, endTime: endTime }
                } else if (column === 'sentenceIdx') {
                    return { column: 'sentenceIdxExp', value: rowIdx, punchlineFlag: tableRow.punchlineFlag, startTime: startTime, endTime: endTime }
                }
            })
        })
        .enter()
        .append('td')
        .attr('class', function(d) {
            return d.column
        })
        .style('background-color', function(d) {
            if (d.punchlineFlag && d.column == 'sentenceIdxExp') return 'lightblue'
        })
        .style('width', function(d) {
            if (d.column == "sentenceIdxExp") {
                return "10px";
            } else {
                return '100%';
            }
        })
        .append('div')
        .attr('class', function(d) {
            return 'divContent ' + d.column
        })
        .style('width', "100%")
        .on('click', function(d) {
            let startTime = d['startTime']
            let endTime = d['endTime']
            pipeService.emitSeekFromTime({ start: startTime, end: endTime });
        })


    d3.selectAll('div.divContent.sentenceIdxExp')
        .html(function(d) {
            return d.value
        })
        .style('user-select', 'none')

    d3.selectAll('div.divContent.sentenceContextExp')
        .selectAll('div.word')
        .data((sentence, sIdx) => {
            //    console.log('sentence: ', sentence['value'])
            let disconnection = 0
            let repetition = 0

            let disconnectionDict = {},
                repetitionDict = {};

            for (let wordIdx = 0; wordIdx < sentence['value']['senSkills'].length; wordIdx++) {
                let wordSkills = sentence['value']['senSkills'][wordIdx]
                if (wordSkills['texthumour']['disconnection'].length > 0) {
                    /////////////////////////////////
                    disconnectionDict[wordIdx.toString()] = disconnection;
                    /////////////////////////////////
                    disconnection += 1
                }
                if (wordSkills['texthumour']['repetition'].length > 0) {
                    /////////////////////////////////
                    repetitionDict[wordIdx.toString()] = repetition;
                    /////////////////////////////////
                    repetition += 1
                }
                if ((wordSkills['texthumour']['repetition'].length == 0)) {
                    repetitionDict[wordIdx.toString()] = 0;
                }
                if (wordSkills['texthumour']['disconnection'].length == 0) {
                    disconnectionDict[wordIdx.toString()] = 0;
                }
            }
            // wordInfo['wordSkills']['texthumour']
            // = sentence['value']['senSkills']
            // console.log('sentence[value][senSkills]: ', sentence['value']['senSkills'])

            return d3.range(sentence['value']['senSkills'].length).map((wordIdx) => {
                return {
                    'rowIdx': sIdx,
                    'word': sentence['value']['senSkills'][wordIdx]['text'],
                    'wordSkills': sentence['value']['senSkills'][wordIdx],
                    'senSkills': sentence['value']['senSkills'],
                    'disconnection': disconnection,
                    'repetition': repetition,
                    // --- repetition, disconnection flags
                    "repetitionFlag": repetitionDict[wordIdx.toString()],
                    "disconnectionFlag": disconnectionDict[wordIdx.toString()],
                }
            })
        })
        .enter()
        .append('div')
        .attr('height', '20px')
        .attr('id', (d, i) => {
            // console.log('d: , word')
            return `word-${d['rowIdx']}-${i}`
        })
        .attr('class', 'word')
        .style('display', 'inline-block')
        .style('position', 'relative')
        .style('margin', '2px')
        .style("margin-bottom", "10px")
        .style('padding', '2px')
        .append('div')
        .html(function(d) {
            return d['word']
        })
        .style('user-select', 'none')
        .style('display', 'inline')
        .each(drawEachWord)

    function drawEachWord(wordInfo, wordInfoIdx) { /* eslint-disable-line */
        // console.log('wordIdx, wordInfo: ', wordInfoIdx, wordInfo);

        ///////////////////////////////////////////////////////////////////////////
        // audio humor
        ///////////////////////////////////////////////////////////////////////////

        let audiohumour = {}
        let audiohumourOrigin = wordInfo['wordSkills']['audiohumour']
        for (let i = 0; i < audiohumourOrigin.length; i++) {
            let audioTech = audiohumourOrigin[i]
            if (typeof(audioTech) == 'string') {
                audiohumour[globalConfig.audioHumorMapping[audioTech]] = audioTech
            } else {
                audiohumour[audioTech[0]] = audioTech[1]
            }
        }
        // console.log('audiohumour: ', audiohumour)

        ///////////////////////////////////////////////////////////////////////////
        // speed
        ///////////////////////////////////////////////////////////////////////////
        let speedSymbol = ""
        let speedColor = "white"
        if (audiohumour.hasOwnProperty('speed')) {
            let speedTech = audiohumour['speed']
            if (speedTech === "slower") {
                speedSymbol = "<<"
            } else if (speedTech === "faster") {
                speedSymbol = ">>"
            }
            if (speedSymbol != "") {
                speedColor = globalConfig.audioColor[speedTech]
            }
        }

        ///////////////////////////////////////////////////////////////////////////
        // volume
        ///////////////////////////////////////////////////////////////////////////
        let volSymbol = ''
        let volColor = 'white'
        if (audiohumour.hasOwnProperty('volume')) {
            // let volColor = 'transparent'
            let volTech = audiohumour['volume']
            volColor = globalConfig.audioColor[volTech]
            if (volTech === "softer") {
                volSymbol = '<i class="fas fa-level-down-alt">'
            } else if (volTech === "louder") {
                volSymbol = '<i class="fas fa-level-up-alt">'
            }
        }

        ///////////////////////////////////////////////////////////////////////////
        // pitch
        ///////////////////////////////////////////////////////////////////////////
        let pitchStyle = ''
        if (audiohumour.hasOwnProperty('pitch')) {
            pitchStyle = 'border-bottom:1.5px solid #9A86D6;'
        }

        ///////////////////////////////////////////////////////////////////////////
        // pause
        ///////////////////////////////////////////////////////////////////////////
        let pauseValue = 0
        let pauseColor = globalConfig.audioColor['pause']
        if (audiohumour.hasOwnProperty('pause')) {
            pauseValue = audiohumour['pause']


            // $(`<div class='pauseTech' style="height: 15px;  display:inline-block; position: relative; margin: 0px 2px -3px 2px; border-radius: 3px;"></div>`).insertBefore(selection.node())
            // //<i class='fas fa-square'></i>
            // d3.select(this.parentNode).select('.speed').style('margin-left', `${Math.ceil(pauseValue*10)}px`)
        }


        ///////////////////////////////////////////////////////////////////////////
        // text humor
        ///////////////////////////////////////////////////////////////////////////
        let texthumour = wordInfo['wordSkills']['texthumour']
            // console.log('texthumour for words: ', texthumour)

        ///////////////////////////////////////////////////////////////////////////
        // word, Alliteration_, Rhyme _, Polarity, Subjectivity(), 
        ///////////////////////////////////////////////////////////////////////////
        let eachWord = wordInfo.word
        let prev = ''
        let middle = wordInfo.word
        let last = ''
        let polarityStyle = ''
        if (texthumour['alliterations'].length > 0) {
            prev = eachWord.slice(0, 3)
            middle = eachWord.slice(3, )
        }
        if (texthumour['rhymes'].length > 0) {
            last = eachWord.slice(-3, eachWord.length)
                // middle = eachWord.slice(0, -3)
            middle = middle.slice(0, -3)
        }
        if (texthumour['polarity'].length > 0) {
            if (texthumour['polarity'][0] > 0) {
                polarityStyle = 'vertical-align: super;'
            } else {
                polarityStyle = 'vertical-align: sub;'
            }
        }
        if ((eachWord.length <= 6) & (texthumour['alliterations'].length > 0) & (texthumour['rhymes'].length > 0)) {
            prev = eachWord
            middle = ''
            last = ''
        }
        if (texthumour['subjectivity'].length > 0) {
            eachWord = `<span style="${polarityStyle}">(<U>${prev}</U>${middle}<U>${last}</U>)</span>`
        } else {
            eachWord = `<span style="${polarityStyle}"><U>${prev}</U>${middle}<U>${last}</U></span>`
        }

        let selection = d3.select(this)

        // adjust speed css
        selection.html(`<div class="outerWord"><div class="incongruity"></div><div class="speed" style="color:${speedColor}; position: absolute; margin-top:12px; display: inline-block;">${speedSymbol}</div><div class="innerWord"><div class="pause" style="width: ${Math.ceil(pauseValue*10)}px; background-color: ${pauseColor};"></div><div class="eachWord" style="${pitchStyle}">${eachWord}</div><div class="volume" style="color: ${volColor};">${volSymbol}</div></div></div>`)

        $(this).find(".speed").css("margin-left", $(this).width() / 3 + "px");

        ///////////////////////////////////////////////////////////////////////////
        // Repetition, Disconnection
        ///////////////////////////////////////////////////////////////////////////
        repetitionFlag['sentenceIdx'] = wordInfo.sIdx
        disconnectionFlag['sentenceIdx'] = wordInfo.sIdx


        if (texthumour['repetition'].length > 0 || texthumour['disconnection'].length > 0) {

            // let incongruityWidth = wordInfo.word.length * 7
            let incongruityWidth = 40;
            // let incongruityHeight = 20 
            let incongruitySvg = selection.select('.incongruity')
                .append('svg')
                .attr('width', incongruityWidth)
                // .attr('height', incongruityHeight)
                .attr('height', 12)

            // incongruitySvg.append('rect')
            //     .attr('width', incongruityWidth)
            //     .attr('height', incongruityHeight)
            //     .style('background-color', 'red')
            //     .style('opacity', 0.1)

            // redo f01e   redo-alt  f2f9
            // undo f0e2   undo-alt f2ea
            let rep_discon_flag = -1;
            // if ((wordInfo['repetition'] == 2 && texthumour['repetition'].length > 0) & (wordInfo['disconnection'] == 2 && texthumour['disconnection'].length > 0)) {
            //     rep_discon_flag = 0;
            // }
            if ((texthumour['repetition'].length > 0) && (texthumour['disconnection'].length > 0) && (wordInfo["disconnectionFlag"] >= wordInfo['disconnection'] - 2)) {
                rep_discon_flag = 0;
            }

            // if (wordInfo['repetition'] == 2 && texthumour['repetition'].length > 0) {
            if (texthumour['repetition'].length > 0 && wordInfo["repetition"] > 1) { // --- filter word repetition that only has single words
                incongruitySvg.append('g')
                    .attr('class', 'repetitionG')
                    ///////////OLD
                    // .attr('transform', 'translate(' + 0 + ', ' + 0.8*incongruityHeight + ')')
                    ///////////OLD
                    .attr('transform', function() {
                        if (rep_discon_flag == 0) {
                            return 'translate(0,10) scale(0.8)'
                        } else {
                            return 'translate(10,10) scale(0.8)'
                        }
                    })
                    .append('text')
                    // .attr('text-anchor', 'left')
                    .attr('class', 'fa')
                    .attr('font-size', '5px')
                    .attr('font-weight', 'lighter')
                    // .attr('color', 'red')
                    .text(function() {
                        // if (repetitionFlag['repetition'] == 0) {
                        //     repetitionFlag['repetition'] += 1
                        //     return '\uf01e'
                        // } else {
                        //     repetitionFlag['repetition'] = 0
                        //     return '\uf0e2'
                        // }
                        if (wordInfo['repetitionFlag'] == 0) {
                            wordInfo['repetitionFlag'] += 1
                            return '\uf01e'
                        } else {
                            // repetitionFlag['repetition'] = 0
                            wordInfo['repetitionFlag'] += 1
                            return '\uf0e2'
                        }

                    })
                    .style('fill', globalConfig.textHumorColor['repetition'])
            }

            // if (wordInfo['disconnection'] == 2 && texthumour['disconnection'].length > 0) {
            if ((texthumour['disconnection'].length > 0) && (wordInfo["disconnection"] > 1) && ((wordInfo['disconnectionFlag'] == wordInfo['disconnection'] - 2) || (wordInfo['disconnectionFlag'] == wordInfo['disconnection'] - 1))) {
                // console.log("disconnection:", wordInfo)
                let disconnectionG = incongruitySvg.append('g')
                    .attr('class', 'disconnectionG')
                if (rep_discon_flag == 0) {
                    disconnectionG.attr('transform', 'translate(' + incongruityWidth / 2 + ', ' + (5) + ') scale(0.8)');
                } else {
                    disconnectionG.attr('transform', 'translate(10,5) scale(0.8)');
                }


                let defs = disconnectionG.append('defs')

                defs.append('marker')
                    .attr('id', 'arrow')
                    .attr('viewBox', '0 -5 10 10')
                    .attr('refX', 5)
                    .attr('refY', 0)
                    .attr('markerWidth', 4)
                    .attr('markerHeight', 4)
                    .attr('orient', 'auto')
                    .append('path')
                    .attr('d', 'M0,-5L10,0L0,5')
                    .attr('class', 'arrowHead')
                    .style("fill", globalConfig.textHumorColor['disconnection'])

                let cx = 0
                let x1 = 0
                let x2 = 0.4 * incongruityWidth
                    // if (disconnectionFlag['disconnection'] == 0) {
                if (wordInfo['disconnectionFlag'] == wordInfo['disconnection'] - 2) {
                    disconnectionFlag['disconnection'] += 1
                    cx = 0
                    x1 = 0
                    x2 = 0.4 * incongruityWidth
                } else {
                    disconnectionFlag['disconnection'] = 0
                    cx = 0.4 * incongruityWidth
                    x1 = 0.4 * incongruityWidth
                    x2 = 0
                }

                disconnectionG.append('circle')
                    .attr('cx', cx)
                    .attr('cy', 0)
                    .attr('r', 4)
                    .attr('fill', globalConfig.textHumorColor['disconnection'])

                disconnectionG.append('line')
                    .attr('x1', x1)
                    .attr('y1', 0)
                    .attr('x2', x2)
                    .attr('y2', 0)
                    .attr('marker-end', 'url(#arrowX)')
                    .style("stroke-dasharray", ("3, 3"))
                    .style('stroke', globalConfig.textHumorColor['disconnection'])
                    .style('stroke-width', '2px')
            }

        }

        // console.log("wordinfo, sentenceidx", repetitionFlag, disconnectionFlag, wordInfo);

    }

    $('.scrollContent').scroll(function() {
        // console.log('scroll: ', $('.scrollContent').scrollTop())
        // let curTableTop = $('.scrollContent').scrollTop()
        // console.log('curTableTop: ', curTableTop)

        for (let i = 0; i < $('.tableRow').length; i++) {
            let elePosition = $(`.tableRow.row-${i}`).position().top - 30
            let elePositionStart = elePosition
            let elePositionEnd = elePositionStart + $(`.tableRow.row-${i}`).height()
            if (elePositionEnd >= 0) {
                let startTime = d3.select(`.tableRow.row-${i}`).data()[0]['startTime']
                _this.timeslider
                    .transition()
                    .duration(200)
                    .attr('d', () => {
                        let d = 'M' + (_this.previewContextMargin.left - 5) + ',' + (_this.yScaler(startTime) + _this.previewContextMargin.top)
                            ///////////////////////////////////////////////////////////////////////
                            //  OLD
                            // d += ' ' + (_this.previewContextWidth+5) + ',' + (_this.yScaler(startTime) + _this.previewContextMargin.top)
                            ///////////////////////////////////////////////////////////////////////
                        d += ' ' + (200 + 5) + ',' + (_this.yScaler(startTime) + _this.previewContextMargin.top)

                        return d
                    })
                break
            }
        }
    })
}

export default DrawExploration;